// import React, {
//   useRef,
//   useState,
//   useEffect,
//   useCallback,
//   useMemo,
// } from "react";
// import "./StockTakeScan.scss";
// import { _Api } from "../api/_call";
// import "rc-slider/assets/index.css";
// import Slider from "rc-slider";
// import { error, loading, Updateloading } from "../common/helpers/toastify";
// import NewSocialModal from "./NewSocialModal";

// import NewFilterModal from "./NewFilterModal";
// import { VoucherList } from "../common/graphql/commonlayouts";
// import { useTranslation } from "react-i18next";
// import PlayIcon from "../../Icons/PlayIcon";
// import SortIcon from "../../Icons/SortIcon";
// import ShareIcon from "../../Icons/ShareIcon";
// import PrintIcon from "../../Icons/PrintIcon";
// import SaveIcon from "../../Icons/SaveIcon";
// import StocksIcon from "Icons/StocksIcon";
// import SearchIcon from "admin/common/icons/SearchIcon";
// import ConnectIcon from "Icons/ConnectIcon";
// import RefreshBtn from "Icons/RefreshBtn";
// import UpdateStockQuantityModal from "./UpdateStockQuantityModal";
// import { useRfidAgent } from "./useRfidAgent";
// import Pause from "Icons/Pause";
// import Freq from "Icons/Freq";
// import Scanned from "Icons/Scanned";
// import Unscanned from "Icons/Unscanned";
// import Conflict from "Icons/Conflict";
// import Pause2 from "Icons/Pause2";
// import RefreshConfirmationModal from "./RefreshConfirmationModal";
// import { trackOrSetValue } from "@testing-library/user-event/dist/cjs/document/trackValue.js";
// import {
//   CrossIcon,
//   DownStockArrow,
//   LocationIcon,
//   ProductDetailHolder,
//   ProductImagePlaceholder,
//   RemoveIcon,
//   ScannedArrow,
//   UpStockArrow,
// } from "./SvgComponent";
// import manualScan from "../../assets/images/manual-scan.png";

// const StockTake = (props) => {
//   const { t } = useTranslation();
//   const dataFetched = useRef();
//   const closePowerBtn = useRef();
//   const modalSaveDataRef = useRef();
//   const freqPopupRef = useRef();
//   const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
//   const [val1, setVal1] = useState([100]);
//   const [val2, setVal2] = useState([100]);
//   const [FiltersData, SetFiltersData] = useState("");
//   const [stocklist, setStocklist] = useState();
//   const [Total, setTotal] = useState();
//   const [Searchvalue, setSearchvalue] = useState("");
//   const [scannedlist, setScannedlist] = useState([]);
//   const [unknownlist, setUnknownlist] = useState([]);
//   const [commanSelected_vouc, setcommanSelected_vouc] = useState();
//   const [socialurl, setSocialurl] = useState();
//   const [shareloader, setShareloader] = useState(false);
//   const [details, setDetails] = useState();
//   const [rfidData, setRfidData] = useState("");
//   const rfidDataRef = useRef();
//   const [useRfid, setUseRfid] = useState(false);
//   const [startRfid, setStartRfid] = useState(false);
//   let [scannedIdArray, setScannedIdArray] = useState([]);
//   let [conflictIdArray, setConflictIdArray] = useState([]);
//   const [powerMenuList, setPowerMenuList] = useState(false);
//   const [freqMenuOpen, setFreqMenuOpen] = useState(false);
//   const [showFourth, setShowFourth] = useState(
//     // () => typeof window !== "undefined" && window.innerWidth > 820,
//     false,
//   );
//   const [statsDrawerOpen, setStatsDrawerOpen] = useState(false);
//   const [statsDrawerMode, setStatsDrawerMode] = useState("scanned"); // "scanned" | "sold"
//   const [drawerGroupBy, setDrawerGroupBy] = useState("item"); // "item" | "collection"
//   const [drawerGroupDropdownOpen, setDrawerGroupDropdownOpen] = useState(false);
//   const [selectedDrawerCategory, setSelectedDrawerCategory] = useState(null);
//   const [stockTakeFliterisOpen, setStockTakeFliterIsOpen] = useState(false);
//   const [headerItem, setHeaderItem] = useState({
//     totalSold: 0,
//     totalPcs: 0,
//     GrossWt: 0,
//   });
//   const [locationFilter, setLocationFilter] = useState(null);
//   const [itemStockSummary, setItemStockSummary] = useState([]);
//   const [collectionStockSummary, setCollectionStockSummary] = useState([]);
//   const [soldProducts, setSoldProducts] = useState([]);
//   const [itemSoldSummary, setItemSoldSummary] = useState([]);
//   const [collectionSoldSummary, setCollectionSoldSummary] = useState([]);
//   const [scanStopped, setScanStopped] = useState(true);
//   const [isStockTakeSaved, setIsStockTakeSaved] = useState(false);
//   const [refresh, setRefresh] = useState(false);
//   const [resume, setResume] = useState(false);
//   const [productPlaceHolder, setProductPlaceHolder] = useState(false);
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" ? window.innerWidth <= 820 : false,
//   );
//   const addedlistRef = useRef();
//   const socialPrint = useRef();

//   const {
//     connectionStatus,
//     readerConnected,
//     connect: rfidConnect,
//     disconnect: rfidDisconnect,
//     startScan: rfidStartScan,
//     stopScan: rfidStopScan,
//     setOnTag,
//     setOnCommandResult,
//     isConnecting,
//   } = useRfidAgent();

//   React.useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 820);
//       if (window.innerWidth <= 820) {
//         setShowFourth((prev) => (window.innerWidth <= 820 ? prev : true));
//       }
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleClickOutside = (event) => {
//     if (
//       closePowerBtn.current &&
//       !closePowerBtn.current.contains(event.target)
//     ) {
//       setPowerMenuList(false);
//     }
//     if (freqPopupRef.current && !freqPopupRef.current.contains(event.target)) {
//       setFreqMenuOpen(false);
//     }
//     if (socialPrint.current && !socialPrint.current.contains(event.target)) {
//       const menu = document.getElementById("stock-take-more-menu");
//       if (menu) menu.classList.remove("open");
//     }
//   };
//   const stockTakelist = useCallback(async (current, firstlimit, filter) => {
//     setStockTakeFliterIsOpen(false);
//     SetFiltersData(filter);
//     try {
//       const postdata = {
//         item: filter?.item ? filter?.item : [],
//         collection: filter?.collection ? filter?.collection : [],
//         metal: filter?.metal ? filter?.metal : [],
//         stone: filter?.stone ? filter?.stone : [],
//         location: filter?.location ? filter?.location : [],
//         size: filter?.size ? filter?.size : [],
//       };
//       let res = await _Api(postdata, `api/v1/Inventory/stocktake/list_new`);
//       if (res?.code === 200) {
//         setHeaderItem({
//           totalSold: res?.totalSold,
//           totalPcs: res?.totalPcs,
//           GrossWt: res?.GrossWt,
//         });
//         setItemStockSummary(res?.itemStockSummary || []);
//         setCollectionStockSummary(res?.collectionStockSummary || []);
//         setSoldProducts(res?.soldProducts || []);
//         setItemSoldSummary(res?.itemSoldSummary || []);
//         setCollectionSoldSummary(res?.collectionSoldSummary || []);
//         setStocklist(res?.data);
//         let count = 0;
//         res?.data.forEach((result, key) => {
//           count = count + result?.po_QTY;
//           if (key === 0) {
//             getdetails(result?._id);
//           }
//         });
//         // setTotal(count);
//         setTotal(res?.data?.length);
//         setScannedlist([]);
//         setUnknownlist([]);
//       } else {
//         error(t("Something Went Wrong!!"));
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const locationWiseCount = (() => {
//     if (!details?.stock_id) return [];

//     const inventoryItems = [
//       ...(stocklist || []),
//       ...(scannedlist || []),
//     ].filter((item) => item?.stock_id === details?.stock_id);

//     const locationMap = inventoryItems.reduce((acc, item) => {
//       const locationId = item?.location_id;
//       if (!locationId) return acc;

//       const qty = Number(item?.po_QTY ?? item?.qty ?? 0) || 0;

//       if (!acc[locationId]) {
//         const filterLoc = locationFilter?.find((loc) => loc?._id === locationId);
//         acc[locationId] = {
//           location_id: locationId,
//           location_name:
//             item?.location_name ||
//             item?.locationName ||
//             filterLoc?.name ||
//             "",
//           p_count: 0,
//         };
//       }
//       acc[locationId].p_count += qty;
//       return acc;
//     }, {});

//     const counts = Object.values(locationMap);
//     if (counts.length) return counts;

//     // Fallback from open product details when item is not in lists
//     if (details?.qty != null && (details?.locationName || details?.location_id)) {
//       return [
//         {
//           location_id: details?.location_id || "",
//           location_name: details?.locationName || "",
//           p_count: Number(details?.qty) || 0,
//         },
//       ];
//     }

//     return [];
//   })();

//   const totalLocationCount = locationWiseCount?.reduce(
//     (total, loc) => total + loc?.p_count,
//     0,
//   );
//   const addedlist = (item_stock_id, isManual = false) => {
//     let Searchvalue = item_stock_id.toString();
//     if (Searchvalue) {
//       setStocklist((currentStock) => {
//         const filtered = currentStock.filter(
//           (item) => item?.stock_id === Searchvalue,
//         );

//         if (filtered.length) {
//           setScannedIdArray((prev) => [
//             ...prev,
//             ...filtered.map((filter) => filter.stock_id),
//           ]);
//           setScannedlist((prevScanned) => [
//             ...prevScanned,
//             ...filtered.map((filter) => ({
//               ...filter,
//               ...(filter?.total_order_qty > 0 ? { low_stock: 1 } : {}),
//               ...(isManual ? { manual_scan: true } : {}),
//             })),
//           ]);

//           const matchedIds = filtered.map((filter) => filter?._id);
//           return currentStock.filter(
//             (item) => !matchedIds.includes(item?._id),
//           );
//         }

//         const normalized = Searchvalue.replace(" ", "");
//         if (
//           scannedIdArray.includes(normalized) === false &&
//           conflictIdArray.includes(normalized) === false &&
//           isNaN(normalized) === false &&
//           Searchvalue !== "" &&
//           Searchvalue !== " "
//         ) {
//           setUnknownlist((prevUnknown) => {
//             if (prevUnknown.some((item) => item?.stock_id === Searchvalue)) {
//               return prevUnknown;
//             }
//             return [
//               ...prevUnknown,
//               {
//                 po_QTY: 0,
//                 SKU: "-",
//                 _id: "",
//                 stock_id: Searchvalue,
//                 location_id: "",
//               },
//             ];
//           });
//           setConflictIdArray((prev) => [...prev, Searchvalue]);
//         }

//         return currentStock;
//       });
//     }

//     setSearchvalue("");
//     setRfidData("");
//   };

//   const deleteunknown = (key, product_id, array) => {
//     setUnknownlist((current) => current.filter((item, index) => index !== key));
//     if (product_id) {
//       setStocklist([...stocklist, array]);
//     }
//   };
//   const deletescanned = (product_id, array) => {
//     setScannedlist((current) =>
//       current.filter((item) => item?._id !== product_id),
//     );
//     setStocklist([...stocklist, array]);
//   };
//   const savelist = async (createLowStock = false) => {
//     try {
//       let total_scanned_qty = scannedlist
//         ? scannedlist?.reduce(
//             (interation, val) =>
//               (interation = interation + parseInt(val.po_QTY)),
//             0,
//           )
//         : "";
//       let total_unscanned_qty = stocklist
//         ? stocklist?.reduce(
//             (interation, val) =>
//               (interation = interation + parseInt(val.po_QTY)),
//             0,
//           )
//         : "";
//       let unknown_qty = unknownlist?.length
//         ? unknownlist.reduce(
//             (interation, val) => (interation = interation + 1),
//             0,
//           )
//         : 0;
//       let GetloadingID = loading();
//       const postdata = {
//         unscanned: stocklist,
//         scanned: scannedlist,
//         voucher_id: commanSelected_vouc,
//         conflict: [],
//         unknown: unknownlist,
//         total_scanned_qty: total_scanned_qty,
//         total_unscanned_qty: total_unscanned_qty,
//         conflict_qty: 0,
//         unknown_qty: unknown_qty,
//         filter: {
//           item: FiltersData?.item ? FiltersData?.item : [],
//           collection: FiltersData?.collection ? FiltersData?.collection : [],
//           metal: FiltersData?.metal ? FiltersData?.metal : [],
//           location: FiltersData?.location ? FiltersData?.location : [],
//           stone: FiltersData?.stone ? FiltersData?.stone : [],
//         },
//         create_low_stock: createLowStock ? 1 : 0,
//         manual_scan: manualscannedlist.length > 0 ? true : false,
//       };
//       let res = await _Api(postdata, `api/v1/Inventory/stocktake/create`);
//       if (res?.code === 200) {
//         Updateloading(t, GetloadingID, t("Successfully Created!"));
//         setIsStockTakeSaved(true);
//       } else {
//         Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };
//   const getdetails = async (product_id, ClickValue = false) => {
//     try {
//       if (ClickValue) {
//         setRfidData(ClickValue);
//       }

//       const postdata = {
//         poProductId: product_id,
//       };
//       let res = await _Api(
//         postdata,
//         `api/v1/Inventory/stocktake/stockTakePuDetailes_new`,
//       );
//       if (res?.code === 200) {
//         setDetails(res?.data);
//       } else {
//         error(t("Something Went Wrong!!"));
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };
//   useEffect(() => {
//     if (dataFetched.current) return;
//     dataFetched.current = true;
//     stockTakelist();
//   }, [stockTakelist]);

//   addedlistRef.current = addedlist;

//   useEffect(() => {
//     setUseRfid(readerConnected);
//   }, [readerConnected]);

//   useEffect(() => {
//     setOnTag((stockId) => {
//       setRfidData(stockId);
//       addedlistRef.current(stockId);
//       setRfidData("");
//     });
//   }, [setOnTag]);

//   useEffect(() => {
//     setOnCommandResult((data) => {
//       if (data.type !== "command_result" || data.action !== "connect") return;
//       const success = data.result?.Success ?? data.result?.success;
//       if (success === false) {
//         error(
//           data.result?.Message ||
//             data.result?.message ||
//             t("RFID connect failed"),
//         );
//       }
//     });
//   }, [setOnCommandResult, t]);

//   const handleRfidConnectToggle = async () => {
//     if (readerConnected || connectionStatus === "connected") {
//       if (startRfid) {
//         rfidStopScan();
//         setStartRfid(false);
//       }
//       rfidDisconnect();
//       setUseRfid(false);
//       return;
//     }

//     try {
//       await rfidConnect();
//     } catch (err) {
//       error(t("Unable to connect RFID agent"));
//       console.log(err, "rfid connect err");
//     }
//   };

//   const handleRfidStartToggle = () => {
//     if (!readerConnected) {
//       error(t("Please connect RFID reader first"));
//       return;
//     }

//     if (startRfid) {
//       rfidStopScan();
//       setStartRfid(false);
//       return;
//     }

//     rfidStartScan();
//     setStartRfid(true);
//   };
//   const getsharelowstocktake = async () => {
//     let total_scanned_qty = scannedlist
//       ? scannedlist?.reduce(
//           (interation, val) => (interation = interation + parseInt(val.po_QTY)),
//           0,
//         )
//       : "";
//     let total_unscanned_qty = stocklist
//       ? stocklist?.reduce(
//           (interation, val) => (interation = interation + parseInt(val.po_QTY)),
//           0,
//         )
//       : "";
//     let unknown_qty = unknownlist?.length
//       ? unknownlist.reduce(
//           (interation, val) => (interation = interation + 1),
//           0,
//         )
//       : 0;
//     setShareloader(true);
//     try {
//       const postdata = {
//         unscanned: stocklist,
//         scanned: scannedlist,
//         voucher_id: commanSelected_vouc,
//         conflict: [],
//         unknown: unknownlist,
//         total_scanned_qty: total_scanned_qty,
//         total_unscanned_qty: total_unscanned_qty,
//         conflict_qty: 0,
//         unknown_qty: unknown_qty,
//         filter: {
//           item: FiltersData?.item ? FiltersData?.item : [],
//           collection: FiltersData?.collection ? FiltersData?.collection : [],
//           metal: FiltersData?.metal ? FiltersData?.metal : [],
//           location: FiltersData?.location ? FiltersData?.location : [],
//           stone: FiltersData?.stone ? FiltersData?.stone : [],
//           fromSave: false,
//         },
//       };
//       let res = await _Api(
//         postdata,
//         `api/v1/Inventory/reports/print/stockTakeDetails`,
//       );

//       if (res.code === 200) {
//         setSocialurl(res?.link);
//         setShareloader(false);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const getprintstocktake = async () => {
//     let total_scanned_qty = scannedlist
//       ? scannedlist?.reduce(
//           (interation, val) => (interation = interation + parseInt(val.po_QTY)),
//           0,
//         )
//       : "";
//     let total_unscanned_qty = stocklist
//       ? stocklist?.reduce(
//           (interation, val) => (interation = interation + parseInt(val.po_QTY)),
//           0,
//         )
//       : "";
//     let unknown_qty = unknownlist?.length
//       ? unknownlist.reduce(
//           (interation, val) => (interation = interation + 1),
//           0,
//         )
//       : 0;
//     let GetloadingID = loading();
//     try {
//       const postdata = {
//         unscanned: stocklist,
//         scanned: scannedlist,
//         voucher_id: commanSelected_vouc,
//         conflict: [],
//         unknown: unknownlist,
//         total_scanned_qty: total_scanned_qty,
//         total_unscanned_qty: total_unscanned_qty,
//         conflict_qty: 0,
//         unknown_qty: unknown_qty,
//         filter: {
//           item: FiltersData?.item ? FiltersData?.item : [],
//           collection: FiltersData?.collection ? FiltersData?.collection : [],
//           metal: FiltersData?.metal ? FiltersData?.metal : [],
//           location: FiltersData?.location ? FiltersData?.location : [],
//           stone: FiltersData?.stone ? FiltersData?.stone : [],
//         },
//         fromSave: false,
//       };

//       let res = await _Api(
//         postdata,
//         "api/v1/Inventory/reports/print/stockTakeDetails",
//       );
//       if (res?.code === 200) {
//         window.open(res?.link, "_blank");
//         Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
//       } else {
//         Updateloading(t, GetloadingID, res?.message, "error");
//       }
//     } catch (err) {
//       console.log(err, "err");
//       Updateloading(t, GetloadingID, err, t("error"));
//     }
//   };

//   const groupFieldMap = {
//     item: "Item_name",
//     collection: "Collection_name",
//   };

//   const groupQtyByField = (list, groupKey) => {
//     const field = groupFieldMap[groupKey] || groupKey;
//     const map = {};
//     (list || []).forEach((item) => {
//       const key = item?.[field] || t("Other");
//       map[key] = (map[key] || 0) + parseInt(item?.po_QTY || 0);
//     });
//     return map;
//   };

//   // Black "total" number now comes straight from the API summary
//   const totalByCategory = useMemo(() => {
//     const summary =
//       drawerGroupBy === "item" ? itemStockSummary : collectionStockSummary;
//     const map = {};
//     (summary || []).forEach((row) => {
//       const key = row?.name || t("Other");
//       map[key] = row?.stock_qty || 0;
//     });
//     return map;
//   }, [itemStockSummary, collectionStockSummary, drawerGroupBy, t]);

//   const scannedByCategory = useMemo(
//     () => groupQtyByField(scannedlist, drawerGroupBy),
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [scannedlist, drawerGroupBy],
//   );

//   const soldTotalByCategory = useMemo(() => {
//     const summary =
//       drawerGroupBy === "item" ? itemSoldSummary : collectionSoldSummary;
//     const map = {};
//     (summary || []).forEach((row) => {
//       const key = row?.name || t("Other");
//       map[key] = row?.sold_count || 0;
//     });
//     return map;
//   }, [itemSoldSummary, collectionSoldSummary, drawerGroupBy, t]);

//   // Enrich sold rows with image / item / collection from current inventory lists
//   const enrichedSoldProducts = useMemo(() => {
//     const inventory = [...(stocklist || []), ...(scannedlist || [])];
//     const singleItemName =
//       itemSoldSummary?.length === 1 ? itemSoldSummary[0]?.name || "" : "";
//     const singleCollectionName =
//       collectionSoldSummary?.length === 1
//         ? collectionSoldSummary[0]?.name || ""
//         : "";
//     return (soldProducts || []).map((sold) => {
//       const match =
//         inventory.find(
//           (item) => String(item?.stock_id) === String(sold?.stock_id),
//         ) || inventory.find((item) => item?.SKU === sold?.SKU);
//       return {
//         ...sold,
//         po_QTY: sold?.qty ?? sold?.po_QTY ?? 0,
//         main_image: match?.main_image || "",
//         Item_name: match?.Item_name || singleItemName || "",
//         Collection_name: match?.Collection_name || singleCollectionName || "",
//         Item: match?.Item || itemSoldSummary?.[0]?.id || "",
//         Collection: match?.Collection || collectionSoldSummary?.[0]?.id || "",
//         _id: match?._id || "",
//       };
//     });
//   }, [
//     soldProducts,
//     stocklist,
//     scannedlist,
//     itemSoldSummary,
//     collectionSoldSummary,
//   ]);

//   const soldByCategory = useMemo(() => {
//     const field = groupFieldMap[drawerGroupBy] || drawerGroupBy;
//     const map = {};
//     enrichedSoldProducts.forEach((item) => {
//       let key = item?.[field] || "";
//       // Fallback: match sold summary by SKU against inventory names already on item
//       if (!key) {
//         key = t("Other");
//       }
//       map[key] = (map[key] || 0) + parseInt(item?.po_QTY || item?.qty || 0);
//     });
//     return map;
//   }, [enrichedSoldProducts, drawerGroupBy, t]);

//   const categoryKeys = useMemo(
//     () => Object.keys(totalByCategory),
//     [totalByCategory],
//   );

//   const soldCategoryKeys = useMemo(
//     () => Object.keys(soldTotalByCategory),
//     [soldTotalByCategory],
//   );

//   const openStatsDrawer = (mode) => {
//     setStatsDrawerMode(mode);
//     setStatsDrawerOpen(true);
//     setSelectedDrawerCategory(null);
//     setDrawerGroupDropdownOpen(false);
//   };
//   useEffect(() => {
//     if (readerConnected) {
//       setScanStopped(false);
//     } else {
//       setScanStopped(true);
//       setStartRfid(false);
//       setResume(false);
//     }
//   }, [readerConnected]);

//   const handleRefreshClear = () => {
//     // Close modal
//     setRefresh(false);

//     // Clear scanned data
//     setScannedlist([]);
//     setUnknownlist([]);
//     setScannedIdArray([]);
//     setConflictIdArray([]);

//     // Reload stock take list
//     stockTakelist();

//     // Stop active scan only — keep device connected if it already is
//     if (startRfid) {
//       rfidStopScan();
//     }

//     setStartRfid(false);
//     setResume(false);
//     // New session: Play enabled again when reader is still connected
//     setScanStopped(!readerConnected);

//     setIsStockTakeSaved(false);
//   };

//   const tags = [details?.metal, details?.size, details?.Collection].filter(
//     Boolean,
//   );

//   const  manualscannedlist = scannedlist.filter(item => item.manual_scan);

//   return (
//     <>
//       <div id="style-stock-take-scan">
//         <div
//           className="main-body stock-take stock-take-scan"
//           onClick={() => {}}
//         >
//           <div className="container">
//             <div className="row">
//               <div className="col-lg-12">
//                 <div className="top-heading-area d-none">
//                   {" "}
//                   <VoucherList
//                     setcommanSelected_vouc={setcommanSelected_vouc}
//                     group={"Stock_Take"}
//                   ></VoucherList>
//                 </div>
//                 <div className="stock-take-toolbar">
//                   <div className="stock-take-toolbar-left">
//                     {!readerConnected || scanStopped ? (
//                       <PlayIcon disabled={!readerConnected || scanStopped} />
//                     ) : (
//                       <div
//                         className="kycTooltip-area-up"
//                         style={{ width: "auto", height: "auto", marginTop: 0 }}
//                         onClick={() => {
//                           if (!readerConnected || scanStopped) return;

//                           if (!startRfid) {
//                             handleRfidStartToggle();
//                             setStartRfid(true);
//                             setResume(false);
//                           } else {
//                             handleRfidStartToggle();
//                             setStartRfid(false);
//                             setResume(true);
//                           }
//                         }}
//                       >
//                         {startRfid ? (
//                           <>
//                             <Pause2 />
//                             <span className="kycTooltip-area-up-text">
//                               Pause
//                             </span>
//                           </>
//                         ) : (
//                           <>
//                             <PlayIcon
//                               disabled={!readerConnected || scanStopped}
//                             />
//                             <span className="kycTooltip-area-up-text">
//                               {resume ? "Resume" : "Play"}
//                             </span>
//                           </>
//                         )}
//                       </div>
//                     )}

//                     <div
//                       className={startRfid || resume ? "stop active" : "stop"}
//                       onClick={() => {
//                         if (!(startRfid || resume)) return;

//                         rfidStopScan();

//                         setStartRfid(false);
//                         setResume(false);

//                         setScanStopped(true);
//                       }}
//                     >
//                       {scanStopped || !(startRfid || resume) ? (
//                         <Pause
//                           disabled={scanStopped || !(startRfid || resume)}
//                         />
//                       ) : (
//                         <div
//                           className="kycTooltip-area-up"
//                           style={{
//                             width: "auto",
//                             height: "auto",
//                             marginTop: 0,
//                           }}
//                         >
//                           <Pause
//                             disabled={scanStopped || !(startRfid || resume)}
//                           />
//                           <span className="kycTooltip-area-up-text">Stop</span>
//                         </div>
//                       )}
//                     </div>
//                     <div
//                       className={scannedlist?.length ? " save active" : " save"}
//                       onClick={() => {
//                         // scannedlist?.length &&
//                         // modalSaveDataRef.current.openModal();
//                         if (!(startRfid || resume)) {
//                           modalSaveDataRef.current.openModal();
//                         }
//                       }}
//                       // title={t("Save")}
//                     >
//                       {!(startRfid || resume) ? (
//                         <div
//                           className="kycTooltip-area-up"
//                           style={{
//                             width: "auto",
//                             height: "auto",
//                             marginTop: 0,
//                           }}
//                         >
//                           {/* <SaveIcon disabled={!scannedlist?.length} /> */}
//                           <SaveIcon />
//                           <span className="kycTooltip-area-up-text">Save</span>
//                         </div>
//                       ) : (
//                         <SaveIcon disabled={startRfid || resume} />
//                       )}
//                     </div>
//                     <div
//                       className=""
//                       onClick={() => {
//                         setRefresh(true);
//                       }}
//                       title={t("Refresh")}
//                     >
//                       {/* {scannedlist?.length ? ( */}
//                       <div
//                         className="kycTooltip-area-up"
//                         style={{
//                           width: "auto",
//                           height: "auto",
//                           marginTop: 0,
//                         }}
//                       >
//                         {/* <RefreshBtn disabled={!scannedlist?.length} /> */}
//                         <RefreshBtn />
//                         <span className="kycTooltip-area-up-text">Refresh</span>
//                       </div>
//                       {/* ) : (
//                         <RefreshBtn disabled={!scannedlist?.length} />
//                       )} */}
//                     </div>

//                     <div
//                       className="stock-take-toolbar-power-wrap"
//                       ref={closePowerBtn}
//                     >
//                       <div
//                         className="kycTooltip-area-up"
//                         style={{ width: "auto", height: "auto", marginTop: 0 }}
//                       >
//                         <div
//                           className="power"
//                           onClick={async () => {
//                             if (!isConnecting) {
//                               await handleRfidConnectToggle();
//                             }
//                           }}
//                           style={{
//                             cursor: isConnecting ? "not-allowed" : "pointer",
//                           }}
//                         >
//                           <ConnectIcon />
//                           {readerConnected && (
//                             <div className="device-connect">
//                               <svg
//                                 width="16"
//                                 height="16"
//                                 viewBox="0 0 16 16"
//                                 fill="none"
//                                 xmlns="http://www.w3.org/2000/svg"
//                               >
//                                 <g clip-path="url(#clip0_2297_6711)">
//                                   <mask
//                                     id="mask0_2297_6711"
//                                     style={{ maskType: "alpha" }}
//                                     maskUnits="userSpaceOnUse"
//                                     x="0"
//                                     y="0"
//                                     width="16"
//                                     height="16"
//                                   >
//                                     <rect
//                                       width="16"
//                                       height="16"
//                                       fill="#D9D9D9"
//                                     />
//                                   </mask>
//                                   <g mask="url(#mask0_2297_6711)">
//                                     <path
//                                       d="M6.36651 10.3437L12.1255 4.58468C12.2246 4.48546 12.3406 4.43479 12.4735 4.43268C12.6064 4.43057 12.7246 4.48124 12.828 4.58468C12.9315 4.68812 12.9832 4.8069 12.9832 4.94101C12.9832 5.07524 12.9315 5.19407 12.828 5.29751L6.78834 11.3475C6.66779 11.468 6.52717 11.5282 6.36651 11.5282C6.20584 11.5282 6.06523 11.468 5.94467 11.3475L3.16134 8.56418C3.06223 8.46496 3.01334 8.34718 3.01467 8.21085C3.0159 8.07462 3.06823 7.95479 3.17167 7.85135C3.27512 7.7479 3.3939 7.69618 3.52801 7.69618C3.66223 7.69618 3.78106 7.7479 3.88451 7.85135L6.36651 10.3437Z"
//                                       fill="white"
//                                     />
//                                   </g>
//                                 </g>
//                                 <defs>
//                                   <clipPath id="clip0_2297_6711">
//                                     <rect width="16" height="16" fill="white" />
//                                   </clipPath>
//                                 </defs>
//                               </svg>
//                             </div>
//                           )}
//                         </div>
//                         <span className="kycTooltip-area-up-text">
//                           {readerConnected ? t("Disconnect") : t("Connect")}
//                         </span>
//                       </div>
//                     </div>
//                     <div
//                       className="stock-take-toolbar-power-wrap"
//                       ref={freqPopupRef}
//                     >
//                       <div
//                         className="kycTooltip-area-up"
//                         style={{ width: "auto", height: "auto", marginTop: 0 }}
//                       >
//                         <div
//                           onClick={() => setFreqMenuOpen(!freqMenuOpen)}
//                           // title={t("Power / Frequency")}
//                         >
//                           <Freq />
//                         </div>
//                         <span className="kycTooltip-area-up-text">Power</span>
//                       </div>

//                       {freqMenuOpen ? (
//                         <div className="stock-take-freq-menu">
//                           <div className="stock-take-freq-menu-row">
//                             <label>{t("Power")}</label>
//                             <div className="stock-take-freq-menu-slider">
//                               <Slider
//                                 min={0}
//                                 max={100}
//                                 value={val1[0]}
//                                 onChange={(v) => setVal1([v])}
//                                 handleStyle={{
//                                   height: "14px",
//                                   width: "14px",
//                                   marginTop: "-6px",
//                                   borderColor: "#52CBC4",
//                                 }}
//                                 trackStyle={{ backgroundColor: "#52CBC4" }}
//                               />
//                             </div>
//                             <span>{val1[0]}%</span>
//                           </div>
//                           <div className="stock-take-freq-menu-row">
//                             <label>{t("Frequency")}</label>
//                             <div className="stock-take-freq-menu-slider">
//                               <Slider
//                                 min={0}
//                                 max={100}
//                                 value={val2[0]}
//                                 onChange={(v) => setVal2([v])}
//                                 handleStyle={{
//                                   height: "14px",
//                                   width: "14px",
//                                   marginTop: "-6px",
//                                   borderColor: "#52CBC4",
//                                 }}
//                                 trackStyle={{ backgroundColor: "#52CBC4" }}
//                               />
//                             </div>
//                             <span>{val2[0]}%</span>
//                           </div>
//                         </div>
//                       ) : (
//                         ""
//                       )}
//                     </div>
//                   </div>
//                   <div className="stock-take-toolbar-right">
//                     <div
//                       id="input_rfid_block"
//                       // className={
//                       //   useRfid
//                       //     ? "stock-take-toolbar-search disabled"
//                       //     : "stock-take-toolbar-search"
//                       // }
//                       className={"stock-take-toolbar-search"}
//                     >
//                       <button
//                         onClick={() => {
//                           addedlist(rfidData ? rfidData : "", true);
//                         }}
//                         className="stock-take-toolbar-search-icon btn-style"
//                       >
//                         <SearchIcon />
//                       </button>

//                       <input
//                         ref={rfidDataRef}
//                         // disabled={useRfid ? "disabled" : ""}
//                         className="stock-take-toolbar-search-input"
//                         onKeyPress={(e) =>
//                           e.key === "Enter" && addedlist(rfidData, true)
//                         }
//                         value={rfidData}
//                         onChange={(e) => {
//                           setRfidData(e.target.value);
//                         }}
//                         placeholder={t("Search or scan Barcode/QR code")}
//                         type="text"
//                         id="sku_stocktake_search"
//                       />
//                       {rfidData ? (
//                         <svg
//                           onClick={(e) => {
//                             setSearchvalue("");
//                             setRfidData("");
//                           }}
//                           width="14"
//                           height="14"
//                           viewBox="0 0 14 14"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M13 13L7 7M7 7L1 1M7 7L13 1M7 7L1 13"
//                             stroke="#767676"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                         </svg>
//                       ) : (
//                         ""
//                       )}
//                       <button
//                         className="com-search-area-left-img scan-img btn-style"
//                         style={{ marginRight: rfidData ? "45px" : "14px" }}
//                       >
//                         <img
//                           src={base_assets + "images/pos/icons/scan-icon.png"}
//                           alt=""
//                         />
//                       </button>
//                     </div>
//                     <div
//                       className="stock-take-toolbar-circle-btn"
//                       onClick={() =>
//                         setStockTakeFliterIsOpen(!stockTakeFliterisOpen)
//                       }
//                       title={t("Filters")}
//                     >
//                       <SortIcon />
//                     </div>
//                     <div
//                       className="stock-take-toolbar-more-wrap"
//                       ref={socialPrint}
//                     >
//                       <div
//                         className="stock-take-toolbar-circle-btn"
//                         onClick={() => setPowerMenuList(false)}
//                         title={t("More")}
//                         id="stock-take-more-menu-btn"
//                         onMouseDown={(e) => {
//                           const menu = document.getElementById(
//                             "stock-take-more-menu",
//                           );
//                           if (menu) menu.classList.toggle("open");
//                         }}
//                       >
//                         <svg
//                           width="4"
//                           height="16"
//                           viewBox="0 0 4 16"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <circle cx="2" cy="2" r="1.6" fill="currentColor" />
//                           <circle cx="2" cy="8" r="1.6" fill="currentColor" />
//                           <circle cx="2" cy="14" r="1.6" fill="currentColor" />
//                         </svg>
//                       </div>
//                       <div
//                         className="stock-take-toolbar-more-menu"
//                         id="stock-take-more-menu"
//                       >
//                         <button
//                           className="stock-take-toolbar-more-menu-item"
//                           data-bs-toggle="modal"
//                           data-bs-target="#newSocialModal"
//                           onClick={() => {
//                             getsharelowstocktake();
//                             document
//                               .getElementById("stock-take-more-menu")
//                               ?.classList.remove("open");
//                           }}
//                         >
//                           <ShareIcon />
//                           <span>{t("Share")}</span>
//                         </button>
//                         <button
//                           className="stock-take-toolbar-more-menu-item"
//                           onClick={() => {
//                             getprintstocktake();
//                             document
//                               .getElementById("stock-take-more-menu")
//                               ?.classList.remove("open");
//                           }}
//                         >
//                           <PrintIcon />
//                           <span>{t("Print")}</span>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="stock-take-inner">
//                   <div className="stock-take-stats-row">
//                     <div className="stock-take-stat total stock-take-stat-totalSection">
//                       <StocksIcon />
//                       <div className="stock-take-stat-text stock-take-stat-totalSection-subTotal">
//                         <label className="stock-take-stat-label">
//                           {t("Total")}
//                         </label>
//                         <div className="stock-take-stat-num-wrap">
//                           <span
//                             className="stock-take-stat-num"
//                             style={{ color: "#3E82F1" }}
//                           >
//                             {Total}
//                           </span>
//                         </div>
//                       </div>
//                       <div
//                         className="stock-take-stat-text"
//                         style={{ gap: "8px" }}
//                       >
//                         <span
//                           style={{
//                             fontSize: "14px",
//                             fontWeight: 600,
//                             color: "#585858",
//                           }}
//                         >
//                           {headerItem?.totalPcs || 0} pcs
//                         </span>
//                         <span style={{ fontSize: "14px", color: "#969696" }}>
//                           ({headerItem?.GrossWt?.toFixed(2) || 0} g)
//                         </span>
//                       </div>
//                     </div>
//                     <div className="stock-take-stats-row2">
//                       <div
//                         className="stock-take-stat scanned"
//                         onClick={() => openStatsDrawer("scanned")}
//                       >
//                         <Scanned />
//                         <div className="stock-take-stat-text">
//                           <label
//                             className="stock-take-stat-label"
//                             style={{ gap: "10px" }}
//                           >
//                             {t("Scanned")}
//                             <ScannedArrow />
//                           </label>
//                           <div style={{display: 'flex', alignItems: 'center', gap: '24px'}}>

//                           <span
//                             className="stock-take-stat-num"
//                             style={{ color: "#52CBC4" }}
//                           >
//                             {scannedlist
//                               ?
//                               //  scannedlist?.reduce(
//                               //     (iteration, val) =>
//                               //       (iteration =
//                               //         iteration + parseInt(val.po_QTY)),
//                               //     0,
//                               //   )
//                               scannedlist?.length
//                               : 0}
//                           </span>
//                           {manualscannedlist?.length>0 &&(

//                           <span style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
//                         <img src={manualScan} alt="manual" style={{width: '16px', height: '16px'}} />
                        
//                         <span style={{fontSize: '14px', color: '#969696'}}>
//                             {manualscannedlist
//                               ? 
//                               // manualscannedlist?.reduce(
//                               //     (iteration, val) =>
//                               //       (iteration =
//                               //         iteration + parseInt(val.po_QTY)),
//                               //     0,
//                               //   )
//                               manualscannedlist?.length
//                               : 0}
//                           </span>
//                           </span>
//                           )}
//                           </div>
//                         </div>
//                       </div>

//                       <div className="stock-take-stat unscanned">
//                         <Unscanned />
//                         <div className="stock-take-stat-text">
//                           <label className="stock-take-stat-label">
//                             {t("Unscanned")}
//                           </label>
//                           <span className="stock-take-stat-num">
//                             {/* {stocklist?.reduce(
//                               (iteration, val) =>
//                                 (iteration = iteration + parseInt(val.po_QTY)),
//                               0,
//                             )} */}
//                             {stocklist?.length}
//                           </span>
//                         </div>
//                       </div>

//                       <div className="stock-take-stat conflict">
//                         <Conflict />
//                         <div className="stock-take-stat-text">
//                           <label className="stock-take-stat-label">
//                             {t("Conflict / Unknown")}
//                           </label>
//                           <span
//                             className="stock-take-stat-num"
//                             style={{ color: "#FF5757" }}
//                           >
//                             {unknownlist?.length
//                               ?
//                               //  unknownlist.reduce(
//                               //     (iteration, val) =>
//                               //       (iteration = iteration + 1),
//                               //     0,
//                               //   )
//                               unknownlist?.length
//                               : 0}
//                           </span>
//                         </div>
//                       </div>

//                       <div className="stock-take-stat sold">
//                       <div
//                         className="stock-take-stat scanned"
//                         onClick={() => openStatsDrawer("sold")}
//                       >
//                         <div className="stock-take-stat-text">
//                           <label className="stock-take-stat-label"        style={{ gap: "10px" }}>
//                             {t("Sold")}
//                             <ScannedArrow />
//                           </label>
//                           <span className="stock-take-stat-num">
//                             {headerItem?.totalSold}
//                           </span>
//                         </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="stock-take-inner-row">
//                     <div
//                       className={
//                         startRfid
//                           ? "stock-take-inner-row-col stock-take-inner-row-col-mid has_overlay"
//                           : "stock-take-inner-row-col stock-take-inner-row-col-mid"
//                       }
//                     >
//                       <div
//                         className={
//                           // useRfid
//                           //   ? "stock-take-inner-row-col-mid-body has_overlay"
//                           //   : "stock-take-inner-row-col-mid-body"
//                           startRfid
//                             ? "stock-take-inner-row-col-mid-body has_overlay"
//                             : "stock-take-inner-row-col-mid-body"
//                         }
//                         onClick={() => {
//                           if (startRfid) {
//                             alert("Please stop scan process first");
//                             return false;
//                           }
//                         }}
//                       >
//                         <div className="stock-take-inner-row-col-mid-body-col">
//                           <div className="stock-take-inner-row-col-mid-body-col-head sku">
//                             <span>{t("Unscanned")}</span>
//                             <span className="stock-take-inner-row-col-mid-body-col-head-count">
//                               {stocklist?.length}
//                             </span>
//                           </div>
//                           <div className="stock-take-inner-row-col-mid-body-col-table-wrap">
//                             <div className="stock-take-inner-row-col-mid-body-col-table">
//                               <>
//                                 {stocklist
//                                   ? stocklist.map((result, key) => {
//                                       return (
//                                         <div
//                                           key={key}
//                                           className="stock-take-inner-row-col-mid-body-col-table-row cursor-pointer"
//                                           style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             borderBottom: "1px solid #e3e3e3",
//                                             padding: "12px 0",
//                                           }}
//                                           onClick={() => {
//                                             setProductPlaceHolder(true);
//                                             setShowFourth(true);

//                                             result?.SKU
//                                               ? getdetails(
//                                                   result?._id,
//                                                   result?.SKU,
//                                                 )
//                                               : getdetails(
//                                                   result?._id,
//                                                   result?.stock_id,
//                                                 );
//                                           }}
//                                         >
//                                           <div style={{fontSize: '14px', color: '#A0A0A0',marginRight: '20px'}}>{key+1}</div>
//                                           <div
//                                             style={{
//                                               display: "flex",
//                                               gap: "2px",
//                                               flexDirection: "column",
//                                               alignItems: "flex-start",
//                                             }}
//                                           >
//                                             <div
//                                               className="link-color "
//                                               //  onClick={() => {
//                                               //     setShowFourth(true);
//                                               //     getdetails(
//                                               //       result?._id,
//                                               //       result?.SKU,
//                                               //     );
//                                               //   }}
//                                             >
//                                               {result?.SKU}
//                                             </div>
//                                             <div
//                                               // className="cursor-pointer"
//                                               style={{
//                                                 fontSize: "12px",
//                                                 color: "#A0A0A0",
//                                                 lineHeight: "16px",
//                                                 paddingLeft: "6px",
//                                               }}
//                                               // onClick={() => {
//                                               //   setShowFourth(true);
//                                               //   getdetails(
//                                               //     result?._id,
//                                               //     result?.stock_id,
//                                               //   );
//                                               // }}
//                                             >
//                                               {result?.stock_id}
//                                             </div>
//                                           </div>
//                                           <div style={{ marginLeft: "auto" }}>
//                                             {result?.po_QTY}
//                                           </div>
//                                         </div>
//                                       );
//                                     })
//                                   : ""}
//                               </>
//                             </div>
//                           </div>
//                         </div>

//                         <div className="stock-take-inner-row-col-mid-body-col">
//                           <div className="stock-take-inner-row-col-mid-body-col-head scanned">
//                             <span>{t("Scanned")}</span>
//                             <span className="stock-take-inner-row-col-mid-body-col-head-count">
//                               {scannedlist?.length}
//                             </span>
//                           </div>
//                           <div className="stock-take-inner-row-col-mid-body-col-table-wrap">
//                             <div className="stock-take-inner-row-col-mid-body-col-table">
//                               <>
//                                 {scannedlist?.length
//                                   ? scannedlist.map((result, key) => {
//                                       return (
//                                         <div
//                                           key={key}
//                                           className="cursor-pointer"
//                                           style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             borderBottom: "1px solid #e3e3e3",
//                                             padding: "12px 0",
//                                           }}
//                                           onClick={() => {
//                                             setProductPlaceHolder(true);
//                                             setShowFourth(true);
//                                             result?.SKU
//                                               ? getdetails(
//                                                   result?._id,
//                                                   result?.SKU,
//                                                 )
//                                               : getdetails(
//                                                   result?._id,
//                                                   result?.stock_id,
//                                                 );
//                                           }}
//                                         >
//                                           <div
//                                             style={{
//                                               display: "flex",
//                                               gap: "2px",
//                                               flexDirection: "column",
//                                               alignItems: "flex-start",
//                                             }}
//                                           >
//                                             <div
//                                               className="link-color"
//                                               // onClick={() =>
//                                               //   getdetails(
//                                               //     result?._id,
//                                               //     result?.SKU,
//                                               //   )
//                                               // }
//                                             >
//                                               {result?.SKU}
//                                             </div>
//                                             <div
//                                               style={{
//                                                 fontSize: "12px",
//                                                 color: "#A0A0A0",
//                                                 lineHeight: "16px",
//                                               }}
//                                               // className="link-color"
//                                               // onClick={() =>
//                                               //   getdetails(
//                                               //     result?._id,
//                                               //     result?.stock_id,
//                                               //   )
//                                               // }
//                                             >
//                                               {result?.stock_id}
//                                             </div>
//                                           </div>
//                                           <div
//                                             style={{
//                                               marginLeft: "auto",
//                                               display: "flex",
//                                               gap: "10px",
//                                               alignItems: "center",
//                                             }}
//                                           >
//                                             {result?.manual_scan ? (
//                                               <div
//                                                 className="kycTooltip-area-up"
//                                                 style={{ width: "auto", height: "auto" }}
//                                               >
//                                                 <img src={manualScan} alt="manual" style={{width: '16px', height: '16px',marginBottom:'5px'}} />
//                                                 <span className="kycTooltip-area-up-text">Manual Scan</span>
//                                               </div>
//                                             ) : null}
//                                             <div>{result?.po_QTY}</div>
//                                             <div>
//                                               <button
//                                                 className="stock-take-inner-row-col-mid-body-col-table-remove-btn btn-style"
//                                                 onClick={() =>
//                                                   deletescanned(
//                                                     result?._id,
//                                                     result,
//                                                   )
//                                                 }
//                                                 title={t("Remove")}
//                                               >
//                                                 <RemoveIcon />
//                                               </button>
//                                             </div>
//                                           </div>
//                                         </div>
//                                       );
//                                     })
//                                   : ""}
//                               </>
//                             </div>
//                           </div>
//                         </div>

//                         <div className="stock-take-inner-row-col-mid-body-col">
//                           <div className="stock-take-inner-row-col-mid-body-col-head unknown">
//                             <span>{t("Conflict/Unknown")}</span>
//                             <span className="stock-take-inner-row-col-mid-body-col-head-count">
//                               {unknownlist?.length}
//                             </span>
//                           </div>
//                           <div className="stock-take-inner-row-col-mid-body-col-table-wrap">
//                             <div className="stock-take-inner-row-col-mid-body-col-table">
//                               <>
//                                 {unknownlist?.length
//                                   ? unknownlist.map((result, key) => {
//                                       let sku = result?.SKU;
//                                       scannedlist.map((v) => {
//                                         if (v._id === sku) {
//                                           return false;
//                                         } else {
//                                           return true;
//                                         }
//                                       });
//                                       // if (isNaN(result?.SKU) === false) {
//                                       if (result.SKU === "-" || isNaN(result.SKU) === false){
//                                         return (
//                                           <div
//                                             key={key}
//                                             style={{
//                                               display: "flex",
//                                               alignItems: "center",
//                                               borderBottom: "1px solid #e3e3e3",
//                                               padding: "12px 0",
//                                             }}
//                                           >
//                                             <div
//                                               style={{
//                                                 display: "flex",
//                                                 gap: "2px",
//                                                 flexDirection: "column",
//                                                 alignItems: "flex-start",
//                                               }}
//                                             >
//                                               <div
//                                                 className="link-color"
//                                                 // onClick={() =>
//                                                 //   getdetails(
//                                                 //     result?._id,
//                                                 //     result?.SKU,
//                                                 //   )
//                                                 // }
//                                               >
//                                                 {result?.SKU}
//                                               </div>
//                                               <div
//                                                 style={{
//                                                   fontSize: "12px",
//                                                   color: "#A0A0A0",
//                                                   lineHeight: "16px",
//                                                 }}
//                                                 // className="link-color"
//                                                 // onClick={() =>
//                                                 //   getdetails(
//                                                 //     result?._id,
//                                                 //     result?.stock_id,
//                                                 //   )
//                                                 // }
//                                               >
//                                                 {result?.stock_id}
//                                               </div>
//                                             </div>
//                                             <div
//                                               style={{
//                                                 marginLeft: "auto",
//                                                 display: "flex",
//                                                 gap: "10px",
//                                                 alignItems: "center",
//                                               }}
//                                             >
//                                               <div>{result?.po_QTY}</div>

//                                               <div>
//                                                 <button
//                                                   className="stock-take-inner-row-col-mid-body-col-table-remove-btn btn-style"
//                                                   onClick={() =>
//                                                     deleteunknown(
//                                                       key,
//                                                       result?._id,
//                                                       result,
//                                                     )
//                                                   }
//                                                   title={t("Remove")}
//                                                 >
//                                                   <RemoveIcon />
//                                                 </button>
//                                               </div>
//                                             </div>
//                                           </div>
//                                         );
//                                       }
//                                       return true;
//                                     })
//                                   : ""}
//                               </>
//                             </div>
//                           </div>
//                         </div>

//                         {showFourth ? (
//                           <>
//                             <div
//                               className="stock-take-mobile-backdrop"
//                               onClick={() => {
//                                 setShowFourth(false);
//                                 setDetails(null);
//                               }}
//                             />
//                             <div
//                               className="stock-take-inner-row-col-mid-body-col stock-take-detail-col"
//                               style={{ gap: "15px" }}
//                             >
//                               <div
//                                 className="stock-take-inner-row-col-mid-body-col-head"
//                                 style={{
//                                   padding: "16px 24px",
//                                   fontSize: "16px",
//                                   fontWeight: 600,
//                                 }}
//                               >
//                                 <span>
//                                   {details?.name || "Product Details"}
//                                 </span>

//                                 <button
//                                   type="button"
//                                   className="stock-take-inner-row-col-right-heading-close"
//                                   onClick={() => {
//                                     setShowFourth(false);
//                                     setDetails(null);
//                                   }}
//                                   title={t("Close")}
//                                 >
//                                   <CrossIcon />
//                                 </button>
//                               </div>
//                               <div
//                                 className="stock-take-inner-row-col-mid-body-col-table-wrap"
//                                 style={{ padding: "0px 24px" }}
//                               >
//                                 <>
//                                   <div className="stock-take-inner-row-col-right-product-img">
//                                     <img src={details?.mainImage} alt="" />
//                                   </div>
//                                   {/* <div
//                                     className="stock-take-inner-row-col-right-product-sku-row"
//                                   >
//                                     <div>
//                                       <span className="stock-take-inner-row-col-right-product-sku-link">
//                                         {details?.SKU}
//                                       </span>
//                                       <p className="stock-take-inner-row-col-right-product-sku-code">
//                                         {details?.stock_id}
//                                       </p>
//                                     </div>
//                                     <div className="stock-take-inner-row-col-right-product-qty-badge">
//                                       <span>{details?.qty}</span>
//                                       <span className="stock-take-inner-row-col-right-product-qty-badge-pcs">{t("pcs")}</span>
                                       
//                                     </div>
//                                   </div>
//                                   <div className="stock-take-inner-row-col-right-product-tags-container">
//                                     <div className="stock-take-inner-row-col-right-product-tags">
//                                       {[
//                                         details?.metal,
//                                         details?.size,
//                                         details?.Collection,
//                                       ]
//                                         .filter(Boolean)
//                                         .join(" | ")}
//                                     </div>

//                                     <div
//                                       style={{
//                                         marginLeft: "auto",
//                                         color:
//                                           details?.low_stock > 0
//                                             ? "#22C55E"
//                                             : "#FF5757",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       <span>{details?.low_stock}</span>{" "}
//                                       {details?.low_stock > 0 ? (
//                                         <UpStockArrow />
//                                       ) : (
//                                         <DownStockArrow />
//                                       )}
//                                     </div>
//                                   </div> */}

//                                   <div className="stock-take-inner-row-col-right-product-sku-row">
//                                     <div className="stock-take-inner-row-col-right-product-sku-row-first-div">
//                                       <div>
//                                         <span className="stock-take-inner-row-col-right-product-sku-link">
//                                           {details?.SKU}
//                                         </span>
//                                         <p className="stock-take-inner-row-col-right-product-sku-code">
//                                           {details?.stock_id}
//                                         </p>
//                                       </div>
//                                       <div className="stock-take-inner-row-col-right-product-tags">
//                                         {/* {[
//                                         details?.metal,
//                                         details?.size,
//                                         details?.Collection,
//                                       ]
//                                         .filter(Boolean)
//                                         .join(" | ")} */}
//                                         {tags.map((tag, index) => (
//                                           <React.Fragment key={index}>
//                                             <span>{tag}</span>

//                                             {index < tags.length - 1 && (
//                                               <div className="product-tag-divider" />
//                                             )}
//                                           </React.Fragment>
//                                         ))}
//                                       </div>
//                                     </div>
//                                     <div className="stock-take-inner-row-col-right-product-sku-row-second-div">
//                                       <div className="stock-take-inner-row-col-right-product-qty-badge">
//                                         <span>{details?.qty}</span>
//                                         <span className="stock-take-inner-row-col-right-product-qty-badge-pcs">
//                                           {t("pcs")}
//                                         </span>
//                                       </div>
//                                       <div
//                                         style={{
//                                           marginLeft: "auto",
//                                           color:
//                                             details?.low_stock > 0
//                                               ? "#22C55E"
//                                               : "#FF5757",
//                                           fontSize: "14px",
//                                         }}
//                                       >
//                                         <span>{details?.low_stock}</span>{" "}
//                                         {details?.low_stock > 0 ? (
//                                           <UpStockArrow />
//                                         ) : (
//                                           <DownStockArrow />
//                                         )}
//                                       </div>
//                                     </div>
//                                   </div>
//                                   <div className="stock-take-detail-static">
//                                     <div
//                                       className="stock-take-detail-static-location"
//                                       style={{
//                                         borderTop: "1px solid #e3e3e3",
//                                         padding: "16px 0 8px",
//                                       }}
//                                     >
//                                       <span className="stock-take-detail-static-location-label">
//                                         <LocationIcon />
//                                       </span>
//                                       <span className="stock-take-detail-static-location-qty">
//                                         {totalLocationCount}
//                                       </span>
//                                     </div>

//                                     {locationWiseCount?.map(
//                                       (location, index) => (
//                                         <div
//                                           className="stock-take-detail-static-location"
//                                           key={index}
//                                           style={{ padding: "0 0 4px 10px" }}
//                                         >
//                                           <span
//                                             className="stock-take-detail-static-location-label"
//                                             style={{ color: "#A0A0A0" }}
//                                           >
//                                             {location.location_name}
//                                           </span>
//                                           <span
//                                             className="stock-take-detail-static-location-qty"
//                                             style={{
//                                               fontWeight: 400,
//                                               color: "#606060",
//                                             }}
//                                           >
//                                             {location.p_count}
//                                           </span>
//                                         </div>
//                                       ),
//                                     )}

//                                     <div className="stock-take-detail-static-metal-head">
//                                       <span>{details?.metal}</span>
//                                       <span style={{ fontWeight: 600 }}>
//                                         {details?.NetWt} g
//                                       </span>
//                                     </div>
//                                     {details?.Stone?.map((stone, index) => (
//                                       <div
//                                         className="stock-take-detail-static-row"
//                                         key={index}
//                                       >
//                                         <span>
//                                           {stone.pcs}&nbsp;&nbsp;
//                                           {stone.stone_code}
//                                         </span>
//                                         <span style={{ fontWeight: 600 }}>
//                                           {stone.cts} c
//                                         </span>
//                                       </div>
//                                     ))}
//                                     <div className="stock-take-detail-static-gross">
//                                       <span>{t("Gross weight")}</span>
//                                       <span style={{ fontWeight: 600 }}>
//                                         {details?.GrossWt} g
//                                       </span>
//                                     </div>
//                                   </div>
//                                 </>
//                               </div>
//                             </div>
//                           </>
//                         ) : (
//                           !productPlaceHolder &&
//                           !isMobile && (
//                             <>
//                               <div
//                                 className="stock-take-mobile-backdrop"
//                                 onClick={() => {
//                                   setShowFourth(false);
//                                   setDetails(null);
//                                 }}
//                               />
//                               <div className="stock-take-inner-row-col-mid-body-col stock-take-detail-col">
//                                 <div
//                                   className="stock-take-inner-row-col-mid-body-col-head"
//                                   style={{
//                                     padding: "16px 24px",
//                                     fontSize: "16px",
//                                     fontWeight: 600,
//                                   }}
//                                 >
//                                   <span>{"Product Details"}</span>

//                                   <button
//                                     type="button"
//                                     className="stock-take-inner-row-col-right-heading-close"
//                                     onClick={() => {
//                                       setProductPlaceHolder(true);
//                                       setShowFourth(false);
//                                       setDetails(null);
//                                     }}
//                                     title={t("Close")}
//                                   >
//                                     <CrossIcon />
//                                   </button>
//                                 </div>
//                                 <div
//                                   className="stock-take-inner-row-col-mid-body-col-table-wrap"
//                                   style={{ padding: "0px 24px" }}
//                                 >
//                                   <div
//                                     className="stock-take-inner-row-col-right-product-img"
//                                     style={{
//                                       display: "flex",
//                                       justifyContent: "center",
//                                     }}
//                                   >
//                                     <ProductImagePlaceholder />
//                                   </div>
//                                   <div
//                                     className="stock-take-inner-row-col-right-empty"
//                                     style={{ padding: "12% 8%" }}
//                                   >
//                                     <div className="stock-take-inner-row-col-right-empty-icon">
//                                       <ProductDetailHolder />
//                                     </div>
//                                     <p className="stock-take-inner-row-col-right-empty-title">
//                                       {t("No item selected")}
//                                     </p>
//                                     <p className="stock-take-inner-row-col-right-empty-sub">
//                                       {t(
//                                         "Click an item in the table to view product details",
//                                       )}
//                                     </p>
//                                   </div>
//                                 </div>
//                               </div>
//                             </>
//                           )
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {statsDrawerOpen ? (
//             <div
//               className="stock-take-drawer-overlay"
//               onClick={() => {
//                 setStatsDrawerOpen(false);
//                 setSelectedDrawerCategory(null);
//               }}
//             >
//               <div
//                 className="stock-take-drawer-group"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 {selectedDrawerCategory ? (
//                   <div className="stock-take-drawer-detail-panel">
//                     <div className="stock-take-drawer-detail-header">
//                       <h3>
//                         {statsDrawerMode === "sold"
//                           ? `${t("Sold")} - ${selectedDrawerCategory}`
//                           : `${t("Unscanned")} - ${selectedDrawerCategory}`}{" "}
//                         <span className="stock-take-drawer-detail-header-unscanned">
//                           {statsDrawerMode === "sold"
//                             ? soldByCategory[selectedDrawerCategory] ||
//                               soldTotalByCategory[selectedDrawerCategory] ||
//                               0
//                             : scannedByCategory[selectedDrawerCategory] || 0}
//                         </span>
//                         {statsDrawerMode === "sold" ? null : (
//                           <>/{totalByCategory[selectedDrawerCategory] || 0}</>
//                         )}
//                       </h3>
//                       <button
//                         className="stock-take-drawer-back-btn"
//                         onClick={() => setSelectedDrawerCategory(null)}
//                       >
//                         <svg
//                           width="24"
//                           height="24"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M11.1389 17L16 12L11.1389 7M16 12L4 12M20 20L20 4"
//                             stroke="#484848"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                           />
//                         </svg>
//                       </button>
//                     </div>

//                     <div className="stock-take-drawer-detail-grid">
//                       {statsDrawerMode === "sold"
//                         ? enrichedSoldProducts
//                             .filter((item) => {
//                               const field =
//                                 groupFieldMap[drawerGroupBy] || drawerGroupBy;
//                               const key = item?.[field] || t("Other");
//                               // If enrichment missed names, still show all sold when only one category
//                               if (
//                                 key === t("Other") &&
//                                 !item?.Item_name &&
//                                 !item?.Collection_name
//                               ) {
//                                 return (
//                                   soldCategoryKeys.length === 1 &&
//                                   soldCategoryKeys[0] === selectedDrawerCategory
//                                 );
//                               }
//                               return key === selectedDrawerCategory;
//                             })
//                             .map((item, idx) => (
//                               <div
//                                 className="stock-take-drawer-detail-item"
//                                 key={idx}
//                               >
//                                 <div className="stock-take-drawer-detail-item-img">
//                                   <img
//                                     src={
//                                       item?.main_image ||
//                                       base_assets + "images/blank-img-2.png"
//                                     }
//                                     alt=""
//                                   />
//                                 </div>
//                                 <p className="stock-take-drawer-detail-item-sku">
//                                   {item?.SKU}
//                                 </p>
//                                 <span className="stock-take-drawer-detail-item-id">
//                                   {item?.stock_id}
//                                 </span>
//                               </div>
//                             ))
//                         : stocklist
//                             ?.filter(
//                               (item) =>
//                                 (item?.[groupFieldMap[drawerGroupBy]] ||
//                                   t("Other")) === selectedDrawerCategory,
//                             )
//                             .map((item, idx) => (
//                               <div
//                                 className="stock-take-drawer-detail-item"
//                                 key={idx}
//                               >
//                                 <div className="stock-take-drawer-detail-item-img">
//                                   <img
//                                     src={
//                                       item?.main_image ||
//                                       base_assets + "images/blank-img-2.png"
//                                     }
//                                     alt=""
//                                   />
//                                 </div>
//                                 <p className="stock-take-drawer-detail-item-sku">
//                                   {item?.SKU}
//                                 </p>
//                                 <span className="stock-take-drawer-detail-item-id">
//                                   {item?.stock_id}
//                                 </span>
//                               </div>
//                             ))}
//                     </div>
//                   </div>
//                 ) : null}

//                 <div className="stock-take-drawer-list-panel">
//                   <div className="stock-take-drawer-header">
//                     <span className="side-popup-scanned-text">
//                       {statsDrawerMode === "sold" ? t("Sold") : t("Scanned")}
//                     </span>
//                     <button
//                       className="stock-take-drawer-close-btn"
//                       onClick={() => {
//                         setStatsDrawerOpen(false);
//                         setSelectedDrawerCategory(null);
//                       }}
//                     >
//                       <CrossIcon />
//                     </button>
//                   </div>

//                   <div className="stock-take-drawer-dropdown-wrap">
//                     <button
//                       className="stock-take-drawer-dropdown-trigger"
//                       onClick={() =>
//                         setDrawerGroupDropdownOpen(!drawerGroupDropdownOpen)
//                       }
//                     >
//                       {drawerGroupBy === "item" ? t("Item") : t("Collection")}
//                       <svg
//                         width="10"
//                         height="6"
//                         viewBox="0 0 10 6"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M1 1L5 5L9 1"
//                           stroke="#585858"
//                           strokeWidth="1.3"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>
//                     </button>

//                     {drawerGroupDropdownOpen ? (
//                       <div className="stock-take-drawer-dropdown-menu">
//                         <div
//                           className={
//                             drawerGroupBy === "item"
//                               ? "stock-take-drawer-dropdown-menu-item active"
//                               : "stock-take-drawer-dropdown-menu-item"
//                           }
//                           onClick={() => {
//                             setDrawerGroupBy("item");
//                             setDrawerGroupDropdownOpen(false);
//                             setSelectedDrawerCategory(null);
//                           }}
//                         >
//                           {t("Item")}
//                           {drawerGroupBy === "item" ? (
//                             <svg
//                               width="12"
//                               height="10"
//                               viewBox="0 0 12 10"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M1 5L4.5 8.5L11 1.5"
//                                 stroke="#212121"
//                                 strokeWidth="1.3"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               />
//                             </svg>
//                           ) : null}
//                         </div>
//                         <div
//                           className={
//                             drawerGroupBy === "collection"
//                               ? "stock-take-drawer-dropdown-menu-item active"
//                               : "stock-take-drawer-dropdown-menu-item"
//                           }
//                           onClick={() => {
//                             setDrawerGroupBy("collection");
//                             setDrawerGroupDropdownOpen(false);
//                             setSelectedDrawerCategory(null);
//                           }}
//                         >
//                           {t("Collection")}
//                           {drawerGroupBy === "collection" ? (
//                             <svg
//                               width="12"
//                               height="10"
//                               viewBox="0 0 12 10"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M1 5L4.5 8.5L11 1.5"
//                                 stroke="#212121"
//                                 strokeWidth="1.3"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               />
//                             </svg>
//                           ) : null}
//                         </div>
//                       </div>
//                     ) : null}
//                   </div>

//                   <div className="stock-take-drawer-list">
//                     {statsDrawerMode === "sold" ? (
//                       soldCategoryKeys.length ? (
//                         soldCategoryKeys.map((cat) => {
//                           const sold = soldTotalByCategory[cat] || 0;
//                           return (
//                             <div
//                               className={
//                                 selectedDrawerCategory === cat
//                                   ? "stock-take-drawer-list-item active"
//                                   : "stock-take-drawer-list-item"
//                               }
//                               key={cat}
//                               onClick={() => setSelectedDrawerCategory(cat)}
//                             >
//                               <span className="stock-take-drawer-list-item-label">
//                                 {cat}
//                               </span>
//                               <span className="stock-take-drawer-list-item-counts">
//                                 <span className="matched">{sold}</span>
//                               </span>
//                             </div>
//                           );
//                         })
//                       ) : (
//                         <p className="stock-take-drawer-empty">{t("No data")}</p>
//                       )
//                     ) : categoryKeys.length ? (
//                       categoryKeys.map((cat) => {
//                         const scanned = scannedByCategory[cat] || 0;
//                         const total = totalByCategory[cat] || 0;
//                         return (
//                           <div
//                             className={
//                               selectedDrawerCategory === cat
//                                 ? "stock-take-drawer-list-item active"
//                                 : "stock-take-drawer-list-item"
//                             }
//                             key={cat}
//                             onClick={() => setSelectedDrawerCategory(cat)}
//                           >
//                             <span className="stock-take-drawer-list-item-label">
//                               {cat}
//                             </span>
//                             <span className="stock-take-drawer-list-item-counts">
//                               <span
//                                 className={
//                                   scanned < total ? "unscanned" : "matched"
//                                 }
//                               >
//                                 {scanned}
//                               </span>
//                               <span className="sep"> / </span>
//                               <span className="total">{total}</span>
//                             </span>
//                           </div>
//                         );
//                       })
//                     ) : (
//                       <p className="stock-take-drawer-empty">{t("No data")}</p>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ) : null}

//           <NewSocialModal shareUrl={socialurl} shareloader={shareloader} />
//           <NewFilterModal
//             submitfiltter={stockTakelist}
//             limit={0}
//             custom_filter_enable={false}
//             stockTakeFliterisOpen={stockTakeFliterisOpen}
//             setStockTakeFliterIsOpen={setStockTakeFliterIsOpen}
//             setLocationFilter={setLocationFilter}
//           />
//           <UpdateStockQuantityModal
//             ref={modalSaveDataRef}
//             scannedlist={scannedlist}
//             onSave={savelist}
//           />
//           <RefreshConfirmationModal
//             open={refresh}
//             title={
//               isStockTakeSaved
//                 ? "Clear stock take data?"
//                 : "Clear stock take data without saving?"
//             }
//             message={
//               isStockTakeSaved
//                 ? "All current scan results will be cleared and a new stock take session will begin."
//                 : "All current scan results will be removed, and a new stock take session will begin."
//             }
//             onCancel={() => setRefresh(false)}
//             onConfirm={handleRefreshClear}
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export default StockTake;




import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import "./StockTakeScan.scss";
import { _Api } from "../api/_call";
import "rc-slider/assets/index.css";
import Slider from "rc-slider";
import { error, loading, Updateloading } from "../common/helpers/toastify";
import NewSocialModal from "./NewSocialModal";

import NewFilterModal from "./NewFilterModal";
import { VoucherList } from "../common/graphql/commonlayouts";
import { useTranslation } from "react-i18next";
import PlayIcon from "../../Icons/PlayIcon";
import SortIcon from "../../Icons/SortIcon";
import ShareIcon from "../../Icons/ShareIcon";
import PrintIcon from "../../Icons/PrintIcon";
import SaveIcon from "../../Icons/SaveIcon";
import StocksIcon from "Icons/StocksIcon";
import SearchIcon from "admin/common/icons/SearchIcon";
import ConnectIcon from "Icons/ConnectIcon";
import RefreshBtn from "Icons/RefreshBtn";
import UpdateStockQuantityModal from "./UpdateStockQuantityModal";
import { useRfidAgent } from "./useRfidAgent";
import Pause from "Icons/Pause";
import Freq from "Icons/Freq";
import Scanned from "Icons/Scanned";
import Unscanned from "Icons/Unscanned";
import Conflict from "Icons/Conflict";
import Pause2 from "Icons/Pause2";
import RefreshConfirmationModal from "./RefreshConfirmationModal";
import { trackOrSetValue } from "@testing-library/user-event/dist/cjs/document/trackValue.js";
import {
  CrossIcon,
  DownStockArrow,
  LocationIcon,
  ProductDetailHolder,
  ProductImagePlaceholder,
  RemoveIcon,
  ScannedArrow,
  UpStockArrow,
} from "./SvgComponent";
import manualScan from "../../assets/images/manual-scan.png";

const StockTake = (props) => {
  const { t } = useTranslation();
  const dataFetched = useRef();
  const closePowerBtn = useRef();
  const modalSaveDataRef = useRef();
  const freqPopupRef = useRef();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [val1, setVal1] = useState([100]);
  const [val2, setVal2] = useState([100]);
  const [FiltersData, SetFiltersData] = useState("");
  const [stocklist, setStocklist] = useState();
  const [Total, setTotal] = useState();
  const [Searchvalue, setSearchvalue] = useState("");
  const [scannedlist, setScannedlist] = useState([]);
  const [unknownlist, setUnknownlist] = useState([]);
  const [conflictlist, setConflictlist] = useState([]);
  const [commanSelected_vouc, setcommanSelected_vouc] = useState();
  const [socialurl, setSocialurl] = useState();
  const [shareloader, setShareloader] = useState(false);
  const [details, setDetails] = useState();
  const [rfidData, setRfidData] = useState("");
  const rfidDataRef = useRef();
  const [useRfid, setUseRfid] = useState(false);
  const [startRfid, setStartRfid] = useState(false);
  let [scannedIdArray, setScannedIdArray] = useState([]);
  let [conflictIdArray, setConflictIdArray] = useState([]);
  const [powerMenuList, setPowerMenuList] = useState(false);
  const [freqMenuOpen, setFreqMenuOpen] = useState(false);
  const [showFourth, setShowFourth] = useState(
    // () => typeof window !== "undefined" && window.innerWidth > 820,
    false,
  );
  const [statsDrawerOpen, setStatsDrawerOpen] = useState(false);
  const [statsDrawerMode, setStatsDrawerMode] = useState("scanned"); // "scanned" | "sold"
  const [drawerGroupBy, setDrawerGroupBy] = useState("item"); // "item" | "collection"
  const [drawerGroupDropdownOpen, setDrawerGroupDropdownOpen] = useState(false);
  const [selectedDrawerCategory, setSelectedDrawerCategory] = useState(null);
  const [stockTakeFliterisOpen, setStockTakeFliterIsOpen] = useState(false);
  const [headerItem, setHeaderItem] = useState({
    totalSold: 0,
    totalPcs: 0,
    GrossWt: 0,
  });
  const [locationFilter, setLocationFilter] = useState(null);
  const [itemStockSummary, setItemStockSummary] = useState([]);
  const [collectionStockSummary, setCollectionStockSummary] = useState([]);
  const [soldProducts, setSoldProducts] = useState([]);
  const [itemSoldSummary, setItemSoldSummary] = useState([]);
  const [collectionSoldSummary, setCollectionSoldSummary] = useState([]);
  const [scanStopped, setScanStopped] = useState(true);
  const [isStockTakeSaved, setIsStockTakeSaved] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [resume, setResume] = useState(false);
  const [productPlaceHolder, setProductPlaceHolder] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 820 : false,
  );
  const addedlistRef = useRef();
  const socialPrint = useRef();
  const soldProductsRef = useRef([]);
  const scannedIdArrayRef = useRef([]);
  const conflictIdArrayRef = useRef([]);

  const {
    connectionStatus,
    readerConnected,
    connect: rfidConnect,
    disconnect: rfidDisconnect,
    startScan: rfidStartScan,
    stopScan: rfidStopScan,
    setOnTag,
    setOnCommandResult,
    isConnecting,
  } = useRfidAgent();

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 820);
      if (window.innerWidth <= 820) {
        setShowFourth((prev) => (window.innerWidth <= 820 ? prev : true));
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClickOutside = (event) => {
    if (
      closePowerBtn.current &&
      !closePowerBtn.current.contains(event.target)
    ) {
      setPowerMenuList(false);
    }
    if (freqPopupRef.current && !freqPopupRef.current.contains(event.target)) {
      setFreqMenuOpen(false);
    }
    if (socialPrint.current && !socialPrint.current.contains(event.target)) {
      const menu = document.getElementById("stock-take-more-menu");
      if (menu) menu.classList.remove("open");
    }
  };
  const stockTakelist = useCallback(async (current, firstlimit, filter) => {
    setStockTakeFliterIsOpen(false);
    SetFiltersData(filter);
    try {
      const postdata = {
        item: filter?.item ? filter?.item : [],
        collection: filter?.collection ? filter?.collection : [],
        metal: filter?.metal ? filter?.metal : [],
        stone: filter?.stone ? filter?.stone : [],
        location: filter?.location ? filter?.location : [],
        size: filter?.size ? filter?.size : [],
      };
      let res = await _Api(postdata, `api/v1/Inventory/stocktake/list_new`);
      if (res?.code === 200) {
        setHeaderItem({
          totalSold: res?.totalSold,
          totalPcs: res?.totalPcs,
          GrossWt: res?.GrossWt,
        });
        setItemStockSummary(res?.itemStockSummary || []);
        setCollectionStockSummary(res?.collectionStockSummary || []);
        setSoldProducts(res?.soldProducts || []);
        setItemSoldSummary(res?.itemSoldSummary || []);
        setCollectionSoldSummary(res?.collectionSoldSummary || []);
        setStocklist(res?.data);
        let count = 0;
        res?.data.forEach((result, key) => {
          count = count + result?.po_QTY;
          if (key === 0) {
            getdetails(result?._id);
          }
        });
        // setTotal(count);
        setTotal(res?.data?.length);
        setScannedlist([]);
        setUnknownlist([]);
        setConflictlist([]);
        setConflictIdArray([]);
      } else {
        error(t("Something Went Wrong!!"));
      }
    } catch (err) {
      console.log(err, "err");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const locationWiseCount = (() => {
    if (!details?.stock_id) return [];

    const inventoryItems = [
      ...(stocklist || []),
      ...(scannedlist || []),
    ].filter((item) => item?.stock_id === details?.stock_id);

    const locationMap = inventoryItems.reduce((acc, item) => {
      const locationId = item?.location_id;
      if (!locationId) return acc;

      const qty = Number(item?.po_QTY ?? item?.qty ?? 0) || 0;

      if (!acc[locationId]) {
        const filterLoc = locationFilter?.find((loc) => loc?._id === locationId);
        acc[locationId] = {
          location_id: locationId,
          location_name:
            item?.location_name ||
            item?.locationName ||
            filterLoc?.name ||
            "",
          p_count: 0,
        };
      }
      acc[locationId].p_count += qty;
      return acc;
    }, {});

    const counts = Object.values(locationMap);
    if (counts.length) return counts;

    // Fallback from open product details when item is not in lists
    if (details?.qty != null && (details?.locationName || details?.location_id)) {
      return [
        {
          location_id: details?.location_id || "",
          location_name: details?.locationName || "",
          p_count: Number(details?.qty) || 0,
        },
      ];
    }

    return [];
  })();

  const totalLocationCount = locationWiseCount?.reduce(
    (total, loc) => total + loc?.p_count,
    0,
  );

  // Keep sold list fresh for RFID/scan bursts (avoid stale closure)
  useEffect(() => {
    soldProductsRef.current = soldProducts || [];
  }, [soldProducts]);

  useEffect(() => {
    scannedIdArrayRef.current = scannedIdArray || [];
  }, [scannedIdArray]);

  useEffect(() => {
    conflictIdArrayRef.current = conflictIdArray || [];
  }, [conflictIdArray]);

  const addedlist = (item_stock_id, isManual = false) => {
    let Searchvalue = item_stock_id.toString();
    if (!Searchvalue || Searchvalue === " ") {
      setSearchvalue("");
      setRfidData("");
      return;
    }

    const normalized = Searchvalue.replace(" ", "");

    // Already handled this tag in this session
    if (
      scannedIdArrayRef.current.map(String).includes(String(normalized)) ||
      conflictIdArrayRef.current.map(String).includes(String(normalized))
    ) {
      setSearchvalue("");
      setRfidData("");
      return;
    }

    const soldMatch = (soldProductsRef.current || []).find(
      (sold) => String(sold?.stock_id) === String(Searchvalue),
    );

    // Order matters: a stock ID can be both in stock and sold when only some of its
    // pieces were sold (e.g. 5 pcs, 1 sold, 4 left). In-stock must win, otherwise the
    // remaining pieces would wrongly land in Conflict and stay unscanned.
    // 1) SCANNED: tag exists in current stock take list
    // 2) CONFLICT: not in stock but sold — leftover tag of a fully sold product
    // 3) UNKNOWN: not in stock and not sold (numeric ids only — existing rule)
    setStocklist((currentStock) => {
      const filtered = (currentStock || []).filter(
        (item) => String(item?.stock_id) === String(Searchvalue),
      );

      if (filtered.length) {
        // Record immediately so a rapid duplicate read of the same tag (already removed
        // from currentStock) is not mistaken for a sold-only Conflict below.
        scannedIdArrayRef.current = [
          ...scannedIdArrayRef.current,
          ...filtered.map((filter) => filter.stock_id),
        ];
        setScannedIdArray((prev) => {
          const next = [
            ...prev,
            ...filtered.map((filter) => filter.stock_id),
          ];
          scannedIdArrayRef.current = next;
          return next;
        });
        setScannedlist((prevScanned) => [
          ...prevScanned,
          ...filtered.map((filter) => ({
            ...filter,
            ...(filter?.total_order_qty > 0 ? { low_stock: 1 } : {}),
            ...(isManual ? { manual_scan: true } : {}),
          })),
        ]);

        const matchedIds = filtered.map((filter) => filter?._id);
        return currentStock.filter((item) => !matchedIds.includes(item?._id));
      }

      // Already scanned (its in-stock row was moved to Scanned): nothing more to do.
      if (scannedIdArrayRef.current.map(String).includes(String(normalized))) {
        return currentStock;
      }

      if (soldMatch) {
        setConflictlist((prevConflict) => {
          if (
            prevConflict.some(
              (item) => String(item?.stock_id) === String(Searchvalue),
            )
          ) {
            return prevConflict;
          }
          return [
            ...prevConflict,
            {
              po_QTY: soldMatch?.qty ?? 0,
              SKU: soldMatch?.SKU || "-",
              _id: "",
              stock_id: Searchvalue,
              location_id: "",
              main_image: soldMatch?.main_image || "",
              entry_type: "conflict",
            },
          ];
        });
        setConflictIdArray((prev) => {
          const next = [...prev, Searchvalue];
          conflictIdArrayRef.current = next;
          return next;
        });
        return currentStock;
      }

      if (isNaN(normalized) === false) {
        setUnknownlist((prevUnknown) => {
          if (
            prevUnknown.some(
              (item) => String(item?.stock_id) === String(Searchvalue),
            )
          ) {
            return prevUnknown;
          }
          return [
            ...prevUnknown,
            {
              po_QTY: 0,
              SKU: "-",
              _id: "",
              stock_id: Searchvalue,
              location_id: "",
              entry_type: "unknown",
            },
          ];
        });
        setConflictIdArray((prev) => {
          const next = [...prev, Searchvalue];
          conflictIdArrayRef.current = next;
          return next;
        });
      }

      return currentStock;
    });

    setSearchvalue("");
    setRfidData("");
  };

  const deleteunknown = (key, product_id, array) => {
    const stockId = array?.stock_id;
    if (array?.entry_type === "conflict") {
      setConflictlist((current) =>
        current.filter((item) => String(item?.stock_id) !== String(stockId)),
      );
    } else {
      setUnknownlist((current) =>
        current.filter((item, index) =>
          stockId != null
            ? String(item?.stock_id) !== String(stockId)
            : index !== key,
        ),
      );
    }
    setConflictIdArray((prev) =>
      prev.filter((id) => String(id) !== String(stockId)),
    );
    if (product_id) {
      setStocklist([...stocklist, array]);
    }
  };
  const deletescanned = (product_id, array) => {
    setScannedlist((current) =>
      current.filter((item) => item?._id !== product_id),
    );
    setStocklist([...stocklist, array]);
  };
  const savelist = async (createLowStock = false,addUnknown = false) => {
    try {
      let total_scanned_qty = scannedlist
        ? scannedlist?.reduce(
            (interation, val) =>
              (interation = interation + parseInt(val.po_QTY)),
            0,
          )
        : "";
      let total_unscanned_qty = stocklist
        ? stocklist?.reduce(
            (interation, val) =>
              (interation = interation + parseInt(val.po_QTY)),
            0,
          )
        : "";
      let unknown_qty = (addUnknown ||unknownlist?.length)
      ? unknownlist.reduce(
          (interation, val) => (interation = interation + 1),
          0,
        )
      : 0;
      let conflict_qty = conflictlist?.length
        ? conflictlist.reduce(
            (interation, val) => (interation = interation + 1),
            0,
          )
        : 0;
      let GetloadingID = loading();
      const postdata = {
        unscanned: stocklist,
        scanned: scannedlist,
        voucher_id: commanSelected_vouc,
        conflict: conflictlist,
        unknown: addUnknown ? unknownlist : [],
        total_scanned_qty: total_scanned_qty,
        total_unscanned_qty: total_unscanned_qty,
        conflict_qty: conflict_qty,
        unknown_qty: unknown_qty,
        filter: {
          item: FiltersData?.item ? FiltersData?.item : [],
          collection: FiltersData?.collection ? FiltersData?.collection : [],
          metal: FiltersData?.metal ? FiltersData?.metal : [],
          location: FiltersData?.location ? FiltersData?.location : [],
          stone: FiltersData?.stone ? FiltersData?.stone : [],
        },
        create_low_stock: createLowStock ? 1 : 0,
        manual_scan: manualscannedlist.length > 0 ? true : false,
      };
      let res = await _Api(postdata, `api/v1/Inventory/stocktake/create`);
      if (res?.code === 200) {
        Updateloading(t, GetloadingID, t("Successfully Created!"));
        setIsStockTakeSaved(true);
      } else {
        Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getdetails = async (product_id, ClickValue = false) => {
    try {
      if (ClickValue) {
        setRfidData(ClickValue);
      }

      const postdata = {
        poProductId: product_id,
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/stocktake/stockTakePuDetailes_new`,
      );
      if (res?.code === 200) {
        setDetails(res?.data);
      } else {
        error(t("Something Went Wrong!!"));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (dataFetched.current) return;
    dataFetched.current = true;
    stockTakelist();
  }, [stockTakelist]);

  addedlistRef.current = addedlist;

  useEffect(() => {
    setUseRfid(readerConnected);
  }, [readerConnected]);

  useEffect(() => {
    setOnTag((stockId) => {
      setRfidData(stockId);
      addedlistRef.current(stockId);
      setRfidData("");
    });
  }, [setOnTag]);

  useEffect(() => {
    setOnCommandResult((data) => {
      if (data.type !== "command_result" || data.action !== "connect") return;
      const success = data.result?.Success ?? data.result?.success;
      if (success === false) {
        error(
          data.result?.Message ||
            data.result?.message ||
            t("RFID connect failed"),
        );
      }
    });
  }, [setOnCommandResult, t]);

  const handleRfidConnectToggle = async () => {
    if (readerConnected || connectionStatus === "connected") {
      if (startRfid) {
        rfidStopScan();
        setStartRfid(false);
      }
      rfidDisconnect();
      setUseRfid(false);
      return;
    }

    try {
      await rfidConnect();
    } catch (err) {
      error(t("Unable to connect RFID agent"));
      console.log(err, "rfid connect err");
    }
  };

  const handleRfidStartToggle = () => {
    if (!readerConnected) {
      error(t("Please connect RFID reader first"));
      return;
    }

    if (startRfid) {
      rfidStopScan();
      setStartRfid(false);
      return;
    }

    rfidStartScan();
    setStartRfid(true);
  };
  const getsharelowstocktake = async () => {
    let total_scanned_qty = scannedlist
      ? scannedlist?.reduce(
          (interation, val) => (interation = interation + parseInt(val.po_QTY)),
          0,
        )
      : "";
    let total_unscanned_qty = stocklist
      ? stocklist?.reduce(
          (interation, val) => (interation = interation + parseInt(val.po_QTY)),
          0,
        )
      : "";
    let unknown_qty = unknownlist?.length
      ? unknownlist.reduce(
          (interation, val) => (interation = interation + 1),
          0,
        )
      : 0;
    let conflict_qty = conflictlist?.length
      ? conflictlist.reduce(
          (interation, val) => (interation = interation + 1),
          0,
        )
      : 0;
    setShareloader(true);
    try {
      const postdata = {
        unscanned: stocklist,
        scanned: scannedlist,
        voucher_id: commanSelected_vouc,
        conflict: conflictlist,
        unknown: unknownlist,
        total_scanned_qty: total_scanned_qty,
        total_unscanned_qty: total_unscanned_qty,
        conflict_qty: conflict_qty,
        unknown_qty: unknown_qty,
        filter: {
          item: FiltersData?.item ? FiltersData?.item : [],
          collection: FiltersData?.collection ? FiltersData?.collection : [],
          metal: FiltersData?.metal ? FiltersData?.metal : [],
          location: FiltersData?.location ? FiltersData?.location : [],
          stone: FiltersData?.stone ? FiltersData?.stone : [],
          fromSave: false,
        },
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/reports/print/stockTakeDetails`,
      );

      if (res.code === 200) {
        setSocialurl(res?.link);
        setShareloader(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getprintstocktake = async () => {
    let total_scanned_qty = scannedlist
      ? scannedlist?.reduce(
          (interation, val) => (interation = interation + parseInt(val.po_QTY)),
          0,
        )
      : "";
    let total_unscanned_qty = stocklist
      ? stocklist?.reduce(
          (interation, val) => (interation = interation + parseInt(val.po_QTY)),
          0,
        )
      : "";
    let unknown_qty = unknownlist?.length
      ? unknownlist.reduce(
          (interation, val) => (interation = interation + 1),
          0,
        )
      : 0;
    let conflict_qty = conflictlist?.length
      ? conflictlist.reduce(
          (interation, val) => (interation = interation + 1),
          0,
        )
      : 0;
    let GetloadingID = loading();
    try {
      const postdata = {
        unscanned: stocklist,
        scanned: scannedlist,
        voucher_id: commanSelected_vouc,
        conflict: conflictlist,
        unknown: unknownlist,
        total_scanned_qty: total_scanned_qty,
        total_unscanned_qty: total_unscanned_qty,
        conflict_qty: conflict_qty,
        unknown_qty: unknown_qty,
        filter: {
          item: FiltersData?.item ? FiltersData?.item : [],
          collection: FiltersData?.collection ? FiltersData?.collection : [],
          metal: FiltersData?.metal ? FiltersData?.metal : [],
          location: FiltersData?.location ? FiltersData?.location : [],
          stone: FiltersData?.stone ? FiltersData?.stone : [],
        },
        fromSave: false,
      };

      let res = await _Api(
        postdata,
        "api/v1/Inventory/reports/print/stockTakeDetails",
      );
      if (res?.code === 200) {
        window.open(res?.link, "_blank");
        Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
      } else {
        Updateloading(t, GetloadingID, res?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err, t("error"));
    }
  };

  const groupFieldMap = {
    item: "Item_name",
    collection: "Collection_name",
  };

  const groupQtyByField = (list, groupKey) => {
    const field = groupFieldMap[groupKey] || groupKey;
    const map = {};
    (list || []).forEach((item) => {
      const key = item?.[field] || t("Other");
      map[key] = (map[key] || 0) + parseInt(item?.po_QTY || 0);
    });
    return map;
  };

  // Black "total" number now comes straight from the API summary
  const totalByCategory = useMemo(() => {
    const summary =
      drawerGroupBy === "item" ? itemStockSummary : collectionStockSummary;
    const map = {};
    (summary || []).forEach((row) => {
      const key = row?.name || t("Other");
      map[key] = row?.stock_qty || 0;
    });
    return map;
  }, [itemStockSummary, collectionStockSummary, drawerGroupBy, t]);

  const scannedByCategory = useMemo(
    () => groupQtyByField(scannedlist, drawerGroupBy),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scannedlist, drawerGroupBy],
  );

  const soldTotalByCategory = useMemo(() => {
    const summary =
      drawerGroupBy === "item" ? itemSoldSummary : collectionSoldSummary;
    const map = {};
    (summary || []).forEach((row) => {
      const key = row?.name || t("Other");
      map[key] = row?.sold_count || 0;
    });
    return map;
  }, [itemSoldSummary, collectionSoldSummary, drawerGroupBy, t]);

  // Enrich sold rows with image / item / collection from current inventory lists
  const enrichedSoldProducts = useMemo(() => {
    const inventory = [...(stocklist || []), ...(scannedlist || [])];
    const singleItemName =
      itemSoldSummary?.length === 1 ? itemSoldSummary[0]?.name || "" : "";
    const singleCollectionName =
      collectionSoldSummary?.length === 1
        ? collectionSoldSummary[0]?.name || ""
        : "";
    return (soldProducts || []).map((sold) => {
      const match =
        inventory.find(
          (item) => String(item?.stock_id) === String(sold?.stock_id),
        ) || inventory.find((item) => item?.SKU === sold?.SKU);
      return {
        ...sold,
        po_QTY: sold?.qty ?? sold?.po_QTY ?? 0,
        main_image: match?.main_image || "",
        Item_name: match?.Item_name || singleItemName || "",
        Collection_name: match?.Collection_name || singleCollectionName || "",
        Item: match?.Item || itemSoldSummary?.[0]?.id || "",
        Collection: match?.Collection || collectionSoldSummary?.[0]?.id || "",
        _id: match?._id || "",
      };
    });
  }, [
    soldProducts,
    stocklist,
    scannedlist,
    itemSoldSummary,
    collectionSoldSummary,
  ]);

  const soldByCategory = useMemo(() => {
    const field = groupFieldMap[drawerGroupBy] || drawerGroupBy;
    const map = {};
    enrichedSoldProducts.forEach((item) => {
      let key = item?.[field] || "";
      // Fallback: match sold summary by SKU against inventory names already on item
      if (!key) {
        key = t("Other");
      }
      map[key] = (map[key] || 0) + parseInt(item?.po_QTY || item?.qty || 0);
    });
    return map;
  }, [enrichedSoldProducts, drawerGroupBy, t]);

  const categoryKeys = useMemo(
    () => Object.keys(totalByCategory),
    [totalByCategory],
  );

  const soldCategoryKeys = useMemo(
    () => Object.keys(soldTotalByCategory),
    [soldTotalByCategory],
  );

  const openStatsDrawer = (mode) => {
    setStatsDrawerMode(mode);
    setStatsDrawerOpen(true);
    setSelectedDrawerCategory(null);
    setDrawerGroupDropdownOpen(false);
  };

  // Combined Conflict + Unknown for the Conflict/Unknown column
  const conflictUnknownList = useMemo(
    () => [
      ...(conflictlist || []).map((item) => ({
        ...item,
        entry_type: item?.entry_type || "conflict",
      })),
      ...(unknownlist || []).map((item) => ({
        ...item,
        entry_type: item?.entry_type || "unknown",
      })),
    ],
    [conflictlist, unknownlist],
  );

  useEffect(() => {
    if (readerConnected) {
      setScanStopped(false);
    } else {
      setScanStopped(true);
      setStartRfid(false);
      setResume(false);
    }
  }, [readerConnected]);

  const handleRefreshClear = () => {
    // Close modal
    setRefresh(false);

    // Clear scanned data
    setScannedlist([]);
    setUnknownlist([]);
    setConflictlist([]);
    setScannedIdArray([]);
    setConflictIdArray([]);

    // Reload stock take list
    stockTakelist();

    // Stop active scan only — keep device connected if it already is
    if (startRfid) {
      rfidStopScan();
    }

    setStartRfid(false);
    setResume(false);
    // New session: Play enabled again when reader is still connected
    setScanStopped(!readerConnected);

    setIsStockTakeSaved(false);
  };

  const tags = [details?.metal, details?.size, details?.Collection].filter(
    Boolean,
  );

  const  manualscannedlist = scannedlist.filter(item => item.manual_scan);

  return (
    <>
      <div id="style-stock-take-scan">
        <div
          className="main-body stock-take stock-take-scan"
          onClick={() => {}}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="top-heading-area d-none">
                  {" "}
                  <VoucherList
                    setcommanSelected_vouc={setcommanSelected_vouc}
                    group={"Stock_Take"}
                  ></VoucherList>
                </div>
                <div className="stock-take-toolbar">
                  <div className="stock-take-toolbar-left">
                    {!readerConnected || scanStopped ? (
                      <PlayIcon disabled={!readerConnected || scanStopped} />
                    ) : (
                      <div
                        className="kycTooltip-area-up"
                        style={{ width: "auto", height: "auto", marginTop: 0 }}
                        onClick={() => {
                          if (!readerConnected || scanStopped) return;

                          if (!startRfid) {
                            handleRfidStartToggle();
                            setStartRfid(true);
                            setResume(false);
                          } else {
                            handleRfidStartToggle();
                            setStartRfid(false);
                            setResume(true);
                          }
                        }}
                      >
                        {startRfid ? (
                          <>
                            <Pause2 />
                            <span className="kycTooltip-area-up-text" style={{zIndex:6}}>
                              Pause
                            </span>
                          </>
                        ) : (
                          <>
                            <PlayIcon
                              disabled={!readerConnected || scanStopped}
                            />
                            <span className="kycTooltip-area-up-text" style={{zIndex:6}}>
                              {resume ? "Resume" : "Play"}
                            </span>
                          </>
                        )}
                      </div>
                    )}

                    <div
                      className={startRfid || resume ? "stop active" : "stop"}
                      onClick={() => {
                        if (!(startRfid || resume)) return;

                        rfidStopScan();

                        setStartRfid(false);
                        setResume(false);

                        setScanStopped(true);
                      }}
                    >
                      {scanStopped || !(startRfid || resume) ? (
                        <Pause
                          disabled={scanStopped || !(startRfid || resume)}
                        />
                      ) : (
                        <div
                          className="kycTooltip-area-up"
                          style={{
                            width: "auto",
                            height: "auto",
                            marginTop: 0,
                          }}
                        >
                          <Pause
                            disabled={scanStopped || !(startRfid || resume)}
                          />
                          <span className="kycTooltip-area-up-text">Stop</span>
                        </div>
                      )}
                    </div>
                    <div
                      className={scannedlist?.length ? " save active" : " save"}
                      onClick={() => {
                        // scannedlist?.length &&
                        // modalSaveDataRef.current.openModal();
                        if (!(startRfid || resume)) {
                          modalSaveDataRef.current.openModal();
                        }
                      }}
                      // title={t("Save")}
                    >
                      {!(startRfid || resume) ? (
                        <div
                          className="kycTooltip-area-up"
                          style={{
                            width: "auto",
                            height: "auto",
                            marginTop: 0,
                          }}
                        >
                          {/* <SaveIcon disabled={!scannedlist?.length} /> */}
                          <SaveIcon />
                          <span className="kycTooltip-area-up-text" style={{zIndex:6}}>Save</span>
                        </div>
                      ) : (
                        <SaveIcon disabled={startRfid || resume} />
                      )}
                    </div>
                    <div
                      className=""
                      onClick={() => {
                        setRefresh(true);
                      }}
                      title={t("Refresh")}
                    >
                      {/* {scannedlist?.length ? ( */}
                      <div
                        className="kycTooltip-area-up"
                        style={{
                          width: "auto",
                          height: "auto",
                          marginTop: 0,
                        }}
                      >
                        {/* <RefreshBtn disabled={!scannedlist?.length} /> */}
                        <RefreshBtn />
                        <span className="kycTooltip-area-up-text" style={{zIndex:6}}>Refresh</span>
                      </div>
                      {/* ) : (
                        <RefreshBtn disabled={!scannedlist?.length} />
                      )} */}
                    </div>

                    <div
                      className="stock-take-toolbar-power-wrap"
                      ref={closePowerBtn}
                    >
                      <div
                        className="kycTooltip-area-up"
                        style={{ width: "auto", height: "auto", marginTop: 0 }}
                      >
                        <div
                          className="power"
                          onClick={async () => {
                            if (!isConnecting) {
                              await handleRfidConnectToggle();
                            }
                          }}
                          style={{
                            cursor: isConnecting ? "not-allowed" : "pointer",
                          }}
                        >
                          <ConnectIcon />
                          {readerConnected && (
                            <div className="device-connect">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_2297_6711)">
                                  <mask
                                    id="mask0_2297_6711"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="16"
                                    height="16"
                                  >
                                    <rect
                                      width="16"
                                      height="16"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_2297_6711)">
                                    <path
                                      d="M6.36651 10.3437L12.1255 4.58468C12.2246 4.48546 12.3406 4.43479 12.4735 4.43268C12.6064 4.43057 12.7246 4.48124 12.828 4.58468C12.9315 4.68812 12.9832 4.8069 12.9832 4.94101C12.9832 5.07524 12.9315 5.19407 12.828 5.29751L6.78834 11.3475C6.66779 11.468 6.52717 11.5282 6.36651 11.5282C6.20584 11.5282 6.06523 11.468 5.94467 11.3475L3.16134 8.56418C3.06223 8.46496 3.01334 8.34718 3.01467 8.21085C3.0159 8.07462 3.06823 7.95479 3.17167 7.85135C3.27512 7.7479 3.3939 7.69618 3.52801 7.69618C3.66223 7.69618 3.78106 7.7479 3.88451 7.85135L6.36651 10.3437Z"
                                      fill="white"
                                    />
                                  </g>
                                </g>
                                <defs>
                                  <clipPath id="clip0_2297_6711">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          )}
                        </div>
                        <span className="kycTooltip-area-up-text" style={{zIndex:6}}>
                          {readerConnected ? t("Disconnect") : t("Connect")}
                        </span>
                      </div>
                    </div>
                    <div
                      className="stock-take-toolbar-power-wrap"
                      ref={freqPopupRef}
                    >
                      <div
                        className="kycTooltip-area-up"
                        style={{ width: "auto", height: "auto", marginTop: 0 }}
                      >
                        <div
                          onClick={() => setFreqMenuOpen(!freqMenuOpen)}
                          // title={t("Power / Frequency")}
                        >
                          <Freq />
                        </div>
                        <span className="kycTooltip-area-up-text" style={{zIndex:6}}>Power</span>
                      </div>

                      {freqMenuOpen ? (
                        <div className="stock-take-freq-menu">
                          <div className="stock-take-freq-menu-row">
                            <label>{t("Power")}</label>
                            <div className="stock-take-freq-menu-slider">
                              <Slider
                                min={0}
                                max={100}
                                value={val1[0]}
                                onChange={(v) => setVal1([v])}
                                handleStyle={{
                                  height: "14px",
                                  width: "14px",
                                  marginTop: "-6px",
                                  borderColor: "#52CBC4",
                                }}
                                trackStyle={{ backgroundColor: "#52CBC4" }}
                              />
                            </div>
                            <span>{val1[0]}%</span>
                          </div>
                          <div className="stock-take-freq-menu-row">
                            <label>{t("Frequency")}</label>
                            <div className="stock-take-freq-menu-slider">
                              <Slider
                                min={0}
                                max={100}
                                value={val2[0]}
                                onChange={(v) => setVal2([v])}
                                handleStyle={{
                                  height: "14px",
                                  width: "14px",
                                  marginTop: "-6px",
                                  borderColor: "#52CBC4",
                                }}
                                trackStyle={{ backgroundColor: "#52CBC4" }}
                              />
                            </div>
                            <span>{val2[0]}%</span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="stock-take-toolbar-right">
                    <div
                      id="input_rfid_block"
                      // className={
                      //   useRfid
                      //     ? "stock-take-toolbar-search disabled"
                      //     : "stock-take-toolbar-search"
                      // }
                      className={"stock-take-toolbar-search"}
                    >
                      <button
                        onClick={() => {
                          addedlist(rfidData ? rfidData : "", true);
                        }}
                        className="stock-take-toolbar-search-icon btn-style"
                      >
                        <SearchIcon />
                      </button>

                      <input
                        ref={rfidDataRef}
                        // disabled={useRfid ? "disabled" : ""}
                        className="stock-take-toolbar-search-input"
                        onKeyPress={(e) =>
                          e.key === "Enter" && addedlist(rfidData, true)
                        }
                        value={rfidData}
                        onChange={(e) => {
                          setRfidData(e.target.value);
                        }}
                        placeholder={t("Search or scan Barcode/QR code")}
                        type="text"
                        id="sku_stocktake_search"
                      />
                      {rfidData ? (
                        <svg
                          onClick={(e) => {
                            setSearchvalue("");
                            setRfidData("");
                          }}
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13 13L7 7M7 7L1 1M7 7L13 1M7 7L1 13"
                            stroke="#767676"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        ""
                      )}
                      <button
                        className="com-search-area-left-img scan-img btn-style"
                        style={{ marginRight: rfidData ? "45px" : "14px" }}
                      >
                        <img
                          src={base_assets + "images/pos/icons/scan-icon.png"}
                          alt=""
                        />
                      </button>
                    </div>
                    <div
                      className="stock-take-toolbar-circle-btn"
                      onClick={() =>
                        setStockTakeFliterIsOpen(!stockTakeFliterisOpen)
                      }
                      title={t("Filters")}
                    >
                      <SortIcon />
                    </div>
                    <div
                      className="stock-take-toolbar-more-wrap"
                      ref={socialPrint}
                    >
                      <div
                        className="stock-take-toolbar-circle-btn"
                        onClick={() => setPowerMenuList(false)}
                        title={t("More")}
                        id="stock-take-more-menu-btn"
                        onMouseDown={(e) => {
                          const menu = document.getElementById(
                            "stock-take-more-menu",
                          );
                          if (menu) menu.classList.toggle("open");
                        }}
                      >
                        <svg
                          width="4"
                          height="16"
                          viewBox="0 0 4 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="2" cy="2" r="1.6" fill="currentColor" />
                          <circle cx="2" cy="8" r="1.6" fill="currentColor" />
                          <circle cx="2" cy="14" r="1.6" fill="currentColor" />
                        </svg>
                      </div>
                      <div
                        className="stock-take-toolbar-more-menu"
                        id="stock-take-more-menu"
                      >
                        <button
                          className="stock-take-toolbar-more-menu-item"
                          data-bs-toggle="modal"
                          data-bs-target="#newSocialModal"
                          onClick={() => {
                            getsharelowstocktake();
                            document
                              .getElementById("stock-take-more-menu")
                              ?.classList.remove("open");
                          }}
                        >
                          <ShareIcon />
                          <span>{t("Share")}</span>
                        </button>
                        <button
                          className="stock-take-toolbar-more-menu-item"
                          onClick={() => {
                            getprintstocktake();
                            document
                              .getElementById("stock-take-more-menu")
                              ?.classList.remove("open");
                          }}
                        >
                          <PrintIcon />
                          <span>{t("Print")}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="stock-take-inner">
                  <div className="stock-take-stats-row">
                    <div className="stock-take-stat total stock-take-stat-totalSection">
                      <StocksIcon />
                      <div className="stock-take-stat-text stock-take-stat-totalSection-subTotal">
                        <label className="stock-take-stat-label">
                          {t("Total")}
                        </label>
                        <div className="stock-take-stat-num-wrap">
                          <span
                            className="stock-take-stat-num"
                            style={{ color: "#3E82F1" }}
                          >
                            {Total}
                          </span>
                        </div>
                      </div>
                      <div
                        className="stock-take-stat-text"
                        style={{ gap: "8px" }}
                      >
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#585858",
                          }}
                        >
                          {headerItem?.totalPcs || 0} pcs
                        </span>
                        <span style={{ fontSize: "14px", color: "#969696" }}>
                          ({headerItem?.GrossWt?.toFixed(2) || 0} g)
                        </span>
                      </div>
                    </div>
                    <div className="stock-take-stats-row2">
                      <div
                        className="stock-take-stat scanned"
                        onClick={() => openStatsDrawer("scanned")}
                      >
                        <Scanned />
                        <div className="stock-take-stat-text">
                          <label
                            className="stock-take-stat-label"
                            style={{ gap: "10px" }}
                          >
                            {t("Scanned")}
                            <ScannedArrow />
                          </label>
                          <div style={{display: 'flex', alignItems: 'center', gap: '24px'}}>

                          <span
                            className="stock-take-stat-num"
                            style={{ color: "#52CBC4" }}
                          >
                            {scannedlist
                              ?
                              //  scannedlist?.reduce(
                              //     (iteration, val) =>
                              //       (iteration =
                              //         iteration + parseInt(val.po_QTY)),
                              //     0,
                              //   )
                              scannedlist?.length
                              : 0}
                          </span>
                          {manualscannedlist?.length>0 &&(

                          <span style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                        <img src={manualScan} alt="manual" style={{width: '16px', height: '16px'}} />
                        
                        <span style={{fontSize: '14px', color: '#969696'}}>
                            {manualscannedlist
                              ? 
                              // manualscannedlist?.reduce(
                              //     (iteration, val) =>
                              //       (iteration =
                              //         iteration + parseInt(val.po_QTY)),
                              //     0,
                              //   )
                              manualscannedlist?.length
                              : 0}
                          </span>
                          </span>
                          )}
                          </div>
                        </div>
                      </div>

                      <div className="stock-take-stat unscanned">
                        <Unscanned />
                        <div className="stock-take-stat-text">
                          <label className="stock-take-stat-label">
                            {t("Unscanned")}
                          </label>
                          <span className="stock-take-stat-num">
                            {/* {stocklist?.reduce(
                              (iteration, val) =>
                                (iteration = iteration + parseInt(val.po_QTY)),
                              0,
                            )} */}
                            {stocklist?.length}
                          </span>
                        </div>
                      </div>

                      <div className="stock-take-stat conflict">
                        <Conflict />
                        <div className="stock-take-stat-text">
                          <label className="stock-take-stat-label">
                            {t("Conflict / Unknown")}
                          </label>
                          <span
                            className="stock-take-stat-num"
                            style={{ color: "#FF5757" }}
                          >
                            {conflictUnknownList?.length || 0}
                          </span>
                        </div>
                      </div>

                      <div className="stock-take-stat sold">
                      <div
                        className="stock-take-stat scanned"
                        onClick={() => openStatsDrawer("sold")}
                      >
                        <div className="stock-take-stat-text">
                          <label className="stock-take-stat-label"        style={{ gap: "10px" }}>
                            {t("Sold")}
                            <ScannedArrow />
                          </label>
                          <span className="stock-take-stat-num">
                            {headerItem?.totalSold}
                          </span>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="stock-take-inner-row">
                    <div
                      className={
                        startRfid
                          ? "stock-take-inner-row-col stock-take-inner-row-col-mid has_overlay"
                          : "stock-take-inner-row-col stock-take-inner-row-col-mid"
                      }
                    >
                      <div
                        className={
                          // useRfid
                          //   ? "stock-take-inner-row-col-mid-body has_overlay"
                          //   : "stock-take-inner-row-col-mid-body"
                          startRfid
                            ? "stock-take-inner-row-col-mid-body has_overlay"
                            : "stock-take-inner-row-col-mid-body"
                        }
                        onClick={() => {
                          if (startRfid) {
                            alert("Please stop scan process first");
                            return false;
                          }
                        }}
                      >
                        <div className="stock-take-inner-row-col-mid-body-col">
                          <div className="stock-take-inner-row-col-mid-body-col-head sku">
                            <span>{t("Unscanned")}</span>
                            <span className="stock-take-inner-row-col-mid-body-col-head-count">
                              {stocklist?.length}
                            </span>
                          </div>
                          <div className="stock-take-inner-row-col-mid-body-col-table-wrap">
                            <div className="stock-take-inner-row-col-mid-body-col-table">
                              <>
                                {stocklist
                                  ? stocklist.map((result, key) => {
                                      return (
                                        <div
                                          key={key}
                                          className="stock-take-inner-row-col-mid-body-col-table-row cursor-pointer"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            borderBottom: "1px solid #e3e3e3",
                                            padding: "12px 0",
                                          }}
                                          onClick={() => {
                                            setProductPlaceHolder(true);
                                            setShowFourth(true);

                                            result?.SKU
                                              ? getdetails(
                                                  result?._id,
                                                  result?.SKU,
                                                )
                                              : getdetails(
                                                  result?._id,
                                                  result?.stock_id,
                                                );
                                          }}
                                        >
                                          <div style={{fontSize: '14px', color: '#A0A0A0',marginRight: '20px'}}>{key+1}</div>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "2px",
                                              flexDirection: "column",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <div
                                              className="link-color "
                                              //  onClick={() => {
                                              //     setShowFourth(true);
                                              //     getdetails(
                                              //       result?._id,
                                              //       result?.SKU,
                                              //     );
                                              //   }}
                                            >
                                              {result?.SKU}
                                            </div>
                                            <div
                                              // className="cursor-pointer"
                                              style={{
                                                fontSize: "12px",
                                                color: "#A0A0A0",
                                                lineHeight: "16px",
                                                paddingLeft: "6px",
                                              }}
                                              // onClick={() => {
                                              //   setShowFourth(true);
                                              //   getdetails(
                                              //     result?._id,
                                              //     result?.stock_id,
                                              //   );
                                              // }}
                                            >
                                              {result?.stock_id}
                                            </div>
                                          </div>
                                          <div style={{ marginLeft: "auto" }}>
                                            {result?.po_QTY}
                                          </div>
                                        </div>
                                      );
                                    })
                                  : ""}
                              </>
                            </div>
                          </div>
                        </div>

                        <div className="stock-take-inner-row-col-mid-body-col">
                          <div className="stock-take-inner-row-col-mid-body-col-head scanned">
                            <span>{t("Scanned")}</span>
                            <span className="stock-take-inner-row-col-mid-body-col-head-count">
                              {scannedlist?.length}
                            </span>
                          </div>
                          <div className="stock-take-inner-row-col-mid-body-col-table-wrap">
                            <div className="stock-take-inner-row-col-mid-body-col-table">
                              <>
                                {scannedlist?.length
                                  ? scannedlist.map((result, key) => {
                                      return (
                                        <div
                                          key={key}
                                          className="cursor-pointer"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            borderBottom: "1px solid #e3e3e3",
                                            padding: "12px 0",
                                          }}
                                          onClick={() => {
                                            setProductPlaceHolder(true);
                                            setShowFourth(true);
                                            result?.SKU
                                              ? getdetails(
                                                  result?._id,
                                                  result?.SKU,
                                                )
                                              : getdetails(
                                                  result?._id,
                                                  result?.stock_id,
                                                );
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "2px",
                                              flexDirection: "column",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <div
                                              className="link-color"
                                              // onClick={() =>
                                              //   getdetails(
                                              //     result?._id,
                                              //     result?.SKU,
                                              //   )
                                              // }
                                            >
                                              {result?.SKU}
                                            </div>
                                            <div
                                              style={{
                                                fontSize: "12px",
                                                color: "#A0A0A0",
                                                lineHeight: "16px",
                                              }}
                                              // className="link-color"
                                              // onClick={() =>
                                              //   getdetails(
                                              //     result?._id,
                                              //     result?.stock_id,
                                              //   )
                                              // }
                                            >
                                              {result?.stock_id}
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              marginLeft: "auto",
                                              display: "flex",
                                              gap: "10px",
                                              alignItems: "center",
                                            }}
                                          >
                                            {result?.manual_scan ? (
                                              <div
                                                className="kycTooltip-area-up"
                                                style={{ width: "auto", height: "auto" }}
                                              >
                                                <img src={manualScan} alt="manual" style={{width: '16px', height: '16px',marginBottom:'5px'}} />
                                                <span className="kycTooltip-area-up-text">Manual Scan</span>
                                              </div>
                                            ) : null}
                                            <div>{result?.po_QTY}</div>
                                            <div>
                                              <button
                                                className="stock-take-inner-row-col-mid-body-col-table-remove-btn btn-style"
                                                onClick={() =>
                                                  deletescanned(
                                                    result?._id,
                                                    result,
                                                  )
                                                }
                                                title={t("Remove")}
                                              >
                                                <RemoveIcon />
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })
                                  : ""}
                              </>
                            </div>
                          </div>
                        </div>

                        <div className="stock-take-inner-row-col-mid-body-col">
                          <div className="stock-take-inner-row-col-mid-body-col-head unknown">
                            <span>{t("Conflict/Unknown")}</span>
                            <span className="stock-take-inner-row-col-mid-body-col-head-count">
                              {conflictUnknownList?.length}
                            </span>
                          </div>
                          <div className="stock-take-inner-row-col-mid-body-col-table-wrap">
                            <div className="stock-take-inner-row-col-mid-body-col-table">
                              <>
                                {conflictUnknownList?.length
                                  ? conflictUnknownList.map((result, key) => {
                                      // Unknown: keep existing filter. Conflict: always show (real SKU).
                                      const isConflict =
                                        result?.entry_type === "conflict";
                                      const showRow =
                                        isConflict ||
                                        result?.SKU === "-" ||
                                        isNaN(result?.SKU) === false;
                                      if (!showRow) return null;

                                      return (
                                          <div
                                            key={`${result?.entry_type}-${result?.stock_id}-${key}`}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              borderBottom: "1px solid #e3e3e3",
                                              padding: "12px 0",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "2px",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <div className="link-color">
                                                {result?.SKU &&
                                                result.SKU !== "-" &&
                                                String(result.SKU) !==
                                                  String(result?.stock_id)
                                                  ? result.SKU
                                                  : "-"}
                                              </div>
                                              <div
                                                style={{
                                                  fontSize: "12px",
                                                  color: "#A0A0A0",
                                                  lineHeight: "16px",
                                                }}
                                              >
                                                {result?.stock_id}
                                              </div>
                                            </div>
                                            <div
                                              style={{
                                                marginLeft: "auto",
                                                display: "flex",
                                                gap: "10px",
                                                alignItems: "center",
                                              }}
                                            >
                                              <div>{result?.po_QTY}</div>

                                              <div>
                                                <button
                                                  className="stock-take-inner-row-col-mid-body-col-table-remove-btn btn-style"
                                                  onClick={() =>
                                                    deleteunknown(
                                                      key,
                                                      result?._id,
                                                      result,
                                                    )
                                                  }
                                                  title={t("Remove")}
                                                >
                                                  <RemoveIcon />
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                      );
                                    })
                                  : ""}
                              </>
                            </div>
                          </div>
                        </div>

                        {showFourth ? (
                          <>
                            <div
                              className="stock-take-mobile-backdrop"
                              onClick={() => {
                                setShowFourth(false);
                                setDetails(null);
                              }}
                            />
                            <div
                              className="stock-take-inner-row-col-mid-body-col stock-take-detail-col"
                              style={{ gap: "15px" }}
                            >
                              <div
                                className="stock-take-inner-row-col-mid-body-col-head"
                                style={{
                                  padding: "16px 24px",
                                  fontSize: "16px",
                                  fontWeight: 600,
                                }}
                              >
                                <span>
                                  {details?.name || "Product Details"}
                                </span>

                                <button
                                  type="button"
                                  className="stock-take-inner-row-col-right-heading-close"
                                  onClick={() => {
                                    setShowFourth(false);
                                    setDetails(null);
                                  }}
                                  title={t("Close")}
                                >
                                  <CrossIcon />
                                </button>
                              </div>
                              <div
                                className="stock-take-inner-row-col-mid-body-col-table-wrap"
                                style={{ padding: "0px 24px" }}
                              >
                                <>
                                  <div className="stock-take-inner-row-col-right-product-img">
                                    <img src={details?.mainImage} alt="" />
                                  </div>
                                  {/* <div
                                    className="stock-take-inner-row-col-right-product-sku-row"
                                  >
                                    <div>
                                      <span className="stock-take-inner-row-col-right-product-sku-link">
                                        {details?.SKU}
                                      </span>
                                      <p className="stock-take-inner-row-col-right-product-sku-code">
                                        {details?.stock_id}
                                      </p>
                                    </div>
                                    <div className="stock-take-inner-row-col-right-product-qty-badge">
                                      <span>{details?.qty}</span>
                                      <span className="stock-take-inner-row-col-right-product-qty-badge-pcs">{t("pcs")}</span>
                                       
                                    </div>
                                  </div>
                                  <div className="stock-take-inner-row-col-right-product-tags-container">
                                    <div className="stock-take-inner-row-col-right-product-tags">
                                      {[
                                        details?.metal,
                                        details?.size,
                                        details?.Collection,
                                      ]
                                        .filter(Boolean)
                                        .join(" | ")}
                                    </div>

                                    <div
                                      style={{
                                        marginLeft: "auto",
                                        color:
                                          details?.low_stock > 0
                                            ? "#22C55E"
                                            : "#FF5757",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span>{details?.low_stock}</span>{" "}
                                      {details?.low_stock > 0 ? (
                                        <UpStockArrow />
                                      ) : (
                                        <DownStockArrow />
                                      )}
                                    </div>
                                  </div> */}

                                  <div className="stock-take-inner-row-col-right-product-sku-row">
                                    <div className="stock-take-inner-row-col-right-product-sku-row-first-div">
                                      <div>
                                        <span className="stock-take-inner-row-col-right-product-sku-link">
                                          {details?.SKU}
                                        </span>
                                        <p className="stock-take-inner-row-col-right-product-sku-code">
                                          {details?.stock_id}
                                        </p>
                                      </div>
                                      <div className="stock-take-inner-row-col-right-product-tags">
                                        {/* {[
                                        details?.metal,
                                        details?.size,
                                        details?.Collection,
                                      ]
                                        .filter(Boolean)
                                        .join(" | ")} */}
                                        {tags.map((tag, index) => (
                                          <React.Fragment key={index}>
                                            <span>{tag}</span>

                                            {index < tags.length - 1 && (
                                              <div className="product-tag-divider" />
                                            )}
                                          </React.Fragment>
                                        ))}
                                      </div>
                                    </div>
                                    <div className="stock-take-inner-row-col-right-product-sku-row-second-div">
                                      <div className="stock-take-inner-row-col-right-product-qty-badge">
                                        <span>{details?.qty}</span>
                                        <span className="stock-take-inner-row-col-right-product-qty-badge-pcs">
                                          {t("pcs")}
                                        </span>
                                      </div>
                                      <div
                                        style={{
                                          marginLeft: "auto",
                                          color:
                                            details?.low_stock > 0
                                              ? "#22C55E"
                                              : "#FF5757",
                                          fontSize: "14px",
                                        }}
                                      >
                                        <span>{details?.low_stock}</span>{" "}
                                        {details?.low_stock > 0 ? (
                                          <UpStockArrow />
                                        ) : (
                                          <DownStockArrow />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="stock-take-detail-static">
                                    <div
                                      className="stock-take-detail-static-location"
                                      style={{
                                        borderTop: "1px solid #e3e3e3",
                                        padding: "16px 0 8px",
                                      }}
                                    >
                                      <span className="stock-take-detail-static-location-label">
                                        <LocationIcon />
                                      </span>
                                      <span className="stock-take-detail-static-location-qty">
                                        {totalLocationCount}
                                      </span>
                                    </div>

                                    {locationWiseCount?.map(
                                      (location, index) => (
                                        <div
                                          className="stock-take-detail-static-location"
                                          key={index}
                                          style={{ padding: "0 0 4px 10px" }}
                                        >
                                          <span
                                            className="stock-take-detail-static-location-label"
                                            style={{ color: "#A0A0A0" }}
                                          >
                                            {location.location_name}
                                          </span>
                                          <span
                                            className="stock-take-detail-static-location-qty"
                                            style={{
                                              fontWeight: 400,
                                              color: "#606060",
                                            }}
                                          >
                                            {location.p_count}
                                          </span>
                                        </div>
                                      ),
                                    )}

                                    <div className="stock-take-detail-static-metal-head">
                                      <span>{details?.metal}</span>
                                      <span style={{ fontWeight: 600 }}>
                                        {details?.NetWt} g
                                      </span>
                                    </div>
                                    {details?.Stone?.map((stone, index) => (
                                      <div
                                        className="stock-take-detail-static-row"
                                        key={index}
                                      >
                                        <span>
                                          {stone.pcs}&nbsp;&nbsp;
                                          {stone.stone_code}
                                        </span>
                                        <span style={{ fontWeight: 600 }}>
                                          {stone.cts} c
                                        </span>
                                      </div>
                                    ))}
                                    <div className="stock-take-detail-static-gross">
                                      <span>{t("Gross weight")}</span>
                                      <span style={{ fontWeight: 600 }}>
                                        {details?.GrossWt} g
                                      </span>
                                    </div>
                                  </div>
                                </>
                              </div>
                            </div>
                          </>
                        ) : (
                          !productPlaceHolder &&
                          !isMobile && (
                            <>
                              <div
                                className="stock-take-mobile-backdrop"
                                onClick={() => {
                                  setShowFourth(false);
                                  setDetails(null);
                                }}
                              />
                              <div className="stock-take-inner-row-col-mid-body-col stock-take-detail-col">
                                <div
                                  className="stock-take-inner-row-col-mid-body-col-head"
                                  style={{
                                    padding: "16px 24px",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                  }}
                                >
                                  <span>{"Product Details"}</span>

                                  <button
                                    type="button"
                                    className="stock-take-inner-row-col-right-heading-close"
                                    onClick={() => {
                                      setProductPlaceHolder(true);
                                      setShowFourth(false);
                                      setDetails(null);
                                    }}
                                    title={t("Close")}
                                  >
                                    <CrossIcon />
                                  </button>
                                </div>
                                <div
                                  className="stock-take-inner-row-col-mid-body-col-table-wrap"
                                  style={{ padding: "0px 24px" }}
                                >
                                  <div
                                    className="stock-take-inner-row-col-right-product-img"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <ProductImagePlaceholder />
                                  </div>
                                  <div
                                    className="stock-take-inner-row-col-right-empty"
                                    style={{ padding: "12% 8%" }}
                                  >
                                    <div className="stock-take-inner-row-col-right-empty-icon">
                                      <ProductDetailHolder />
                                    </div>
                                    <p className="stock-take-inner-row-col-right-empty-title">
                                      {t("No item selected")}
                                    </p>
                                    <p className="stock-take-inner-row-col-right-empty-sub">
                                      {t(
                                        "Click an item in the table to view product details",
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {statsDrawerOpen ? (
            <div
              className="stock-take-drawer-overlay"
              onClick={() => {
                setStatsDrawerOpen(false);
                setSelectedDrawerCategory(null);
              }}
            >
              <div
                className="stock-take-drawer-group"
                onClick={(e) => e.stopPropagation()}
              >
                {selectedDrawerCategory ? (
                  <div className="stock-take-drawer-detail-panel">
                    <div className="stock-take-drawer-detail-header">
                      <h3>
                        {statsDrawerMode === "sold"
                          ? `${t("Sold")} - ${selectedDrawerCategory}`
                          : `${t("Unscanned")} - ${selectedDrawerCategory}`}{" "}
                        <span className="stock-take-drawer-detail-header-unscanned">
                          {statsDrawerMode === "sold"
                            ? soldByCategory[selectedDrawerCategory] ||
                              soldTotalByCategory[selectedDrawerCategory] ||
                              0
                            : scannedByCategory[selectedDrawerCategory] || 0}
                        </span>
                        {statsDrawerMode === "sold" ? null : (
                          <>/{totalByCategory[selectedDrawerCategory] || 0}</>
                        )}
                      </h3>
                      <button
                        className="stock-take-drawer-back-btn"
                        onClick={() => setSelectedDrawerCategory(null)}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.1389 17L16 12L11.1389 7M16 12L4 12M20 20L20 4"
                            stroke="#484848"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                    </div>

                    <div className="stock-take-drawer-detail-grid">
                      {statsDrawerMode === "sold"
                        ? enrichedSoldProducts
                            .filter((item) => {
                              const field =
                                groupFieldMap[drawerGroupBy] || drawerGroupBy;
                              const key = item?.[field] || t("Other");
                              // If enrichment missed names, still show all sold when only one category
                              if (
                                key === t("Other") &&
                                !item?.Item_name &&
                                !item?.Collection_name
                              ) {
                                return (
                                  soldCategoryKeys.length === 1 &&
                                  soldCategoryKeys[0] === selectedDrawerCategory
                                );
                              }
                              return key === selectedDrawerCategory;
                            })
                            .map((item, idx) => (
                              <div
                                className="stock-take-drawer-detail-item"
                                key={idx}
                              >
                                <div className="stock-take-drawer-detail-item-img">
                                  <img
                                    src={
                                      item?.main_image ||
                                      base_assets + "images/blank-img-2.png"
                                    }
                                    alt=""
                                  />
                                </div>
                                <p className="stock-take-drawer-detail-item-sku">
                                  {item?.SKU}
                                </p>
                                <span className="stock-take-drawer-detail-item-id">
                                  {item?.stock_id}
                                </span>
                              </div>
                            ))
                        : stocklist
                            ?.filter(
                              (item) =>
                                (item?.[groupFieldMap[drawerGroupBy]] ||
                                  t("Other")) === selectedDrawerCategory,
                            )
                            .map((item, idx) => (
                              <div
                                className="stock-take-drawer-detail-item"
                                key={idx}
                              >
                                <div className="stock-take-drawer-detail-item-img">
                                  <img
                                    src={
                                      item?.main_image ||
                                      base_assets + "images/blank-img-2.png"
                                    }
                                    alt=""
                                  />
                                </div>
                                <p className="stock-take-drawer-detail-item-sku">
                                  {item?.SKU}
                                </p>
                                <span className="stock-take-drawer-detail-item-id">
                                  {item?.stock_id}
                                </span>
                              </div>
                            ))}
                    </div>
                  </div>
                ) : null}

                <div className="stock-take-drawer-list-panel">
                  <div className="stock-take-drawer-header">
                    <span className="side-popup-scanned-text">
                      {statsDrawerMode === "sold" ? t("Sold") : t("Scanned")}
                    </span>
                    <button
                      className="stock-take-drawer-close-btn"
                      onClick={() => {
                        setStatsDrawerOpen(false);
                        setSelectedDrawerCategory(null);
                      }}
                    >
                      <CrossIcon />
                    </button>
                  </div>

                  <div className="stock-take-drawer-dropdown-wrap">
                    <button
                      className="stock-take-drawer-dropdown-trigger"
                      onClick={() =>
                        setDrawerGroupDropdownOpen(!drawerGroupDropdownOpen)
                      }
                    >
                      {drawerGroupBy === "item" ? t("Item") : t("Collection")}
                      <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L9 1"
                          stroke="#585858"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>

                    {drawerGroupDropdownOpen ? (
                      <div className="stock-take-drawer-dropdown-menu">
                        <div
                          className={
                            drawerGroupBy === "item"
                              ? "stock-take-drawer-dropdown-menu-item active"
                              : "stock-take-drawer-dropdown-menu-item"
                          }
                          onClick={() => {
                            setDrawerGroupBy("item");
                            setDrawerGroupDropdownOpen(false);
                            setSelectedDrawerCategory(null);
                          }}
                        >
                          {t("Item")}
                          {drawerGroupBy === "item" ? (
                            <svg
                              width="12"
                              height="10"
                              viewBox="0 0 12 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 5L4.5 8.5L11 1.5"
                                stroke="#212121"
                                strokeWidth="1.3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ) : null}
                        </div>
                        <div
                          className={
                            drawerGroupBy === "collection"
                              ? "stock-take-drawer-dropdown-menu-item active"
                              : "stock-take-drawer-dropdown-menu-item"
                          }
                          onClick={() => {
                            setDrawerGroupBy("collection");
                            setDrawerGroupDropdownOpen(false);
                            setSelectedDrawerCategory(null);
                          }}
                        >
                          {t("Collection")}
                          {drawerGroupBy === "collection" ? (
                            <svg
                              width="12"
                              height="10"
                              viewBox="0 0 12 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 5L4.5 8.5L11 1.5"
                                stroke="#212121"
                                strokeWidth="1.3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                  </div>

                  <div className="stock-take-drawer-list">
                    {statsDrawerMode === "sold" ? (
                      soldCategoryKeys.length ? (
                        soldCategoryKeys.map((cat) => {
                          const sold = soldTotalByCategory[cat] || 0;
                          return (
                            <div
                              className={
                                selectedDrawerCategory === cat
                                  ? "stock-take-drawer-list-item active"
                                  : "stock-take-drawer-list-item"
                              }
                              key={cat}
                              onClick={() => setSelectedDrawerCategory(cat)}
                            >
                              <span className="stock-take-drawer-list-item-label">
                                {cat}
                              </span>
                              <span className="stock-take-drawer-list-item-counts">
                                <span className="matched">{sold}</span>
                              </span>
                            </div>
                          );
                        })
                      ) : (
                        <p className="stock-take-drawer-empty">{t("No data")}</p>
                      )
                    ) : categoryKeys.length ? (
                      categoryKeys.map((cat) => {
                        const scanned = scannedByCategory[cat] || 0;
                        const total = totalByCategory[cat] || 0;
                        return (
                          <div
                            className={
                              selectedDrawerCategory === cat
                                ? "stock-take-drawer-list-item active"
                                : "stock-take-drawer-list-item"
                            }
                            key={cat}
                            onClick={() => setSelectedDrawerCategory(cat)}
                          >
                            <span className="stock-take-drawer-list-item-label">
                              {cat}
                            </span>
                            <span className="stock-take-drawer-list-item-counts">
                              <span
                                className={
                                  scanned < total ? "unscanned" : "matched"
                                }
                              >
                                {scanned}
                              </span>
                              <span className="sep"> / </span>
                              <span className="total">{total}</span>
                            </span>
                          </div>
                        );
                      })
                    ) : (
                      <p className="stock-take-drawer-empty">{t("No data")}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <NewSocialModal shareUrl={socialurl} shareloader={shareloader} />
          <NewFilterModal
            submitfiltter={stockTakelist}
            limit={0}
            custom_filter_enable={false}
            stockTakeFliterisOpen={stockTakeFliterisOpen}
            setStockTakeFliterIsOpen={setStockTakeFliterIsOpen}
            setLocationFilter={setLocationFilter}
          />
          <UpdateStockQuantityModal
            ref={modalSaveDataRef}
            scannedlist={scannedlist}
            unknownlist={unknownlist}
            onSave={savelist}
          />
          <RefreshConfirmationModal
            open={refresh}
            title={
              isStockTakeSaved
                ? "Clear stock take data?"
                : "Clear stock take data without saving?"
            }
            message={
              isStockTakeSaved
                ? "All current scan results will be cleared and a new stock take session will begin."
                : "All current scan results will be removed, and a new stock take session will begin."
            }
            onCancel={() => setRefresh(false)}
            onConfirm={handleRefreshClear}
          />
        </div>
      </div>
    </>
  );
};

export default StockTake;
